var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataCollectionHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 613,
    height: 484,
    viewBox: "0 0 613 484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M539.745 306.289H517.205L531.534 314.572L517.205 322.854H539.745L554.074 314.572L539.745 306.289Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M517.205 322.854L531.534 314.572V298.007L517.205 306.289V322.854Z",
    fill: "#BDC1E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M517.206 322.854L502.877 314.572V298.007L517.206 306.289V322.854Z",
    fill: "#D0D4F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M517.206 306.289L502.877 298.007L517.206 289.724L531.535 298.007L517.206 306.289Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M604.304 289.322H590.539L599.233 294.388L590.539 299.454H604.304L612.998 294.388L604.304 289.322Z",
    fill: "url(#paint1_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M590.539 299.454L599.233 294.388V284.337L590.539 289.322V299.454Z",
    fill: "#CACACB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M590.54 299.454L581.846 294.388V284.337L590.54 289.322V299.454Z",
    fill: "#F1ECEC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M590.54 289.322L581.846 284.337L590.54 279.351L599.234 284.337L590.54 289.322Z",
    fill: "#F1ECEC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M560.675 82.0202C559.87 81.5377 558.502 81.1357 556.973 80.814C555.443 80.4924 553.672 80.3315 552.062 80.3315H523.243C521.633 80.3315 520.587 80.4924 520.023 80.814C519.54 81.1357 519.54 81.5377 520.345 82.0202V100.032C519.54 100.515 519.46 100.917 520.023 101.239C520.506 101.56 521.633 101.721 523.243 101.721H552.062C553.672 101.721 555.363 101.56 556.973 101.239C558.502 100.917 559.87 100.515 560.675 100.032V82.0202Z",
    fill: "url(#paint2_linear)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M505.292 92.7151L519.701 100.998C520.506 101.48 521.231 101.48 521.714 101.158C522.197 100.837 522.519 100.193 522.519 99.3089V82.6636C522.519 81.7791 522.197 80.7337 521.714 79.8492C521.231 78.9646 520.506 78.1605 519.701 77.678L505.292 69.3956C504.487 68.9131 503.763 68.9131 503.28 69.2348C502.797 69.5564 502.475 70.1997 502.475 71.0843V87.7296C502.475 88.6141 502.797 89.6594 503.28 90.544C503.763 91.5089 504.487 92.313 505.292 92.7151Z",
    fill: "#313131"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M522.519 99.3893V82.744C522.519 81.8595 522.197 80.8141 521.714 79.9296C521.231 79.0451 520.506 78.2409 519.701 77.7585L505.292 69.476C504.487 68.9936 503.762 68.9936 503.279 69.3152L522.116 58.4596C522.599 58.1379 523.324 58.2183 524.129 58.6204L538.538 66.9028C539.343 67.3853 540.067 68.109 540.55 69.074C541.033 69.9585 541.355 71.0039 541.355 71.8884V88.5337C541.355 89.4182 541.033 90.0615 540.55 90.3832L521.714 101.239C522.197 100.917 522.519 100.274 522.519 99.3893Z",
    fill: "#292929"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M524.693 78.2409C524.21 77.3564 523.485 76.5522 522.68 76.0698L508.271 67.7873C507.466 67.3049 506.742 67.3049 506.259 67.6265L505.373 68.109C505.856 67.7873 506.581 67.8677 507.386 68.2698L521.795 76.5522C522.6 77.0347 523.324 77.7584 523.807 78.7234C524.29 79.6079 524.612 80.6533 524.612 81.5378V98.1831C524.612 99.0676 524.29 99.7109 523.807 100.033L524.693 99.5501C525.176 99.2284 525.498 98.5851 525.498 97.7006V81.0553C525.498 80.1708 525.176 79.1254 524.693 78.2409Z",
    fill: "url(#paint3_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M527.109 76.7935C526.626 75.909 525.901 75.1049 525.096 74.6224L510.687 66.3399C509.882 65.8575 509.158 65.8575 508.675 66.1791L507.789 66.6616C508.272 66.3399 508.997 66.4204 509.802 66.8224L524.211 75.1049C525.016 75.5873 525.74 76.311 526.223 77.276C526.706 78.1605 527.028 79.2059 527.028 80.0904V96.7357C527.028 97.6202 526.706 98.2635 526.223 98.5852L527.109 98.1027C527.592 97.7811 527.914 97.1378 527.914 96.2532V79.6883C527.914 78.7234 527.592 77.7585 527.109 76.7935Z",
    fill: "url(#paint4_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M529.523 75.4266C529.04 74.542 528.315 73.7379 527.51 73.2554L513.101 64.973C512.296 64.4905 511.572 64.4905 511.089 64.8122L510.203 65.2947C510.686 64.973 511.411 65.0534 512.216 65.4555L526.625 73.7379C527.43 74.2204 528.154 74.9441 528.637 75.909C529.12 76.7936 529.442 77.8389 529.442 78.7235V95.3688C529.442 96.2533 529.12 96.8966 528.637 97.2182L529.523 96.7358C530.006 96.4141 530.328 95.7708 530.328 94.8863V78.241C530.328 77.3565 530.006 76.3111 529.523 75.4266Z",
    fill: "url(#paint5_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M531.937 74.0595C531.454 73.175 530.729 72.3709 529.924 71.8884L515.515 63.6059C514.71 63.1235 513.986 63.1235 513.503 63.4451L512.617 63.9276C513.1 63.6059 513.825 63.6863 514.63 64.0884L529.039 72.3709C529.844 72.8533 530.568 73.577 531.051 74.542C531.534 75.4265 531.856 76.4719 531.856 77.3564V94.0017C531.856 94.8862 531.534 95.5295 531.051 95.8512L531.937 95.3687C532.42 95.047 532.742 94.4038 532.742 93.5192V76.8739C532.742 75.909 532.42 74.944 531.937 74.0595Z",
    fill: "url(#paint6_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M534.353 72.6121C533.87 71.7276 533.145 70.9235 532.34 70.441L517.931 62.1586C517.126 61.6761 516.402 61.6761 515.919 61.9977L515.033 62.4802C515.516 62.1585 516.241 62.239 517.046 62.641L531.455 70.9235C532.26 71.4059 532.984 72.1296 533.467 73.0946C533.95 73.9791 534.272 75.0245 534.272 75.909V92.5543C534.272 93.4388 533.95 94.0821 533.467 94.4038L534.353 93.9213C534.836 93.5997 535.158 92.9564 535.158 92.0718V75.4265C535.238 74.542 534.916 73.5771 534.353 72.6121Z",
    fill: "url(#paint7_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M536.767 71.2452C536.284 70.3606 535.56 69.5565 534.755 69.074L520.345 60.7916C519.54 60.3091 518.816 60.3091 518.333 60.6308L517.447 61.1133C517.93 60.7916 518.655 60.872 519.46 61.2741L533.869 69.5565C534.674 70.039 535.399 70.7627 535.882 71.7276C536.365 72.6122 536.687 73.6575 536.687 74.5421V91.1874C536.687 92.0719 536.365 92.7152 535.882 93.0368L536.767 92.5544C537.25 92.2327 537.572 91.5894 537.572 90.7049V74.0596C537.653 73.1751 537.331 72.1297 536.767 71.2452Z",
    fill: "url(#paint8_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M539.183 69.8781C538.7 68.9936 537.976 68.1895 537.171 67.707L522.761 59.4245C521.956 58.9421 521.232 58.9421 520.749 59.2637L519.863 59.7462C520.346 59.4245 521.071 59.505 521.876 59.907L536.285 68.1895C537.09 68.6719 537.815 69.3956 538.298 70.3606C538.781 71.3255 539.103 72.2905 539.103 73.175V89.8203C539.103 90.7048 538.781 91.3481 538.298 91.6698L539.183 91.1873C539.666 90.8657 539.988 90.2224 539.988 89.3378V72.6925C540.069 71.7276 539.747 70.7626 539.183 69.8781Z",
    fill: "url(#paint9_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M471.564 170.554H430.992L434.132 177.389H471.564V170.554Z",
    fill: "url(#paint10_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M462.385 161.467H424.551L424.873 165.89H462.385V161.467Z",
    fill: "url(#paint11_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M422.057 155.115C420.769 154.23 418.837 155.758 418.273 157.366C418.273 158.09 418.756 159.216 418.756 159.216C418.756 159.216 420.849 163.88 421.574 164.684C422.298 165.488 425.196 166.614 426.565 165.408C427.611 164.121 425.599 163.317 425.196 162.03C424.713 160.342 424.955 158.975 424.472 157.769C424.15 156.723 422.057 155.115 422.057 155.115Z",
    fill: "#C0162E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M418.433 157.045C418.433 157.768 418.916 158.894 418.916 158.894C418.916 158.894 421.009 163.558 421.734 164.362C422.458 165.166 425.356 166.292 426.805 165.086C426.886 165.005 426.886 164.925 426.966 164.845C426.966 165.005 426.886 165.166 426.725 165.327C425.356 166.533 422.378 165.408 421.734 164.603C421.009 163.799 418.916 159.135 418.916 159.135C418.916 159.135 418.433 157.929 418.433 157.286C418.353 157.206 418.353 157.125 418.433 157.045Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M425.518 156.16C424.874 155.758 422.378 154.793 422.378 154.793C422.378 154.793 422.137 155.115 421.815 155.195H421.734C421.09 155.195 419.963 155.758 420.688 157.045C422.056 159.538 425.196 159.377 424.874 158.251C424.552 157.608 425.196 156.643 425.518 156.16Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M424.727 159.006C424.807 158.604 424.968 157.8 423.922 157.639C422.875 157.478 421.668 157.96 421.829 158.604C421.99 159.89 424.566 159.408 424.727 159.006Z",
    fill: "#59595B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M420.93 154.874C422.138 153.265 430.832 142.731 435.018 140.641C433.649 134.851 430.027 127.292 431.154 121.101H439.928C439.928 121.101 445.16 139.515 441.779 143.938C439.284 147.234 428.095 155.758 423.909 158.412C422.54 158.412 420.447 156.08 420.93 154.874Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M428.414 170.152C426.885 170.393 426.482 172.805 427.207 174.333C427.69 174.896 428.897 175.379 428.897 175.379C428.897 175.379 433.647 177.309 434.693 177.389C435.74 177.469 438.155 177.067 438.316 175.218C438.155 174.092 437.189 173.77 436.062 173.127C434.532 172.243 433.244 170.956 432.037 170.313C431.071 169.911 428.414 170.152 428.414 170.152Z",
    fill: "#C0162E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M434.694 176.906C433.567 176.826 428.657 174.816 428.657 174.816C428.657 174.816 427.53 174.333 427.047 173.851C427.127 174.012 427.127 174.253 427.208 174.414C427.691 174.976 428.898 175.459 428.898 175.459C428.898 175.459 433.648 177.389 434.694 177.469C435.741 177.55 438.156 177.148 438.317 175.298V175.218C437.834 176.665 435.66 176.987 434.694 176.906Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M431.636 168.544C430.911 168.624 428.416 169.75 428.416 169.75C428.416 169.75 428.496 170.071 428.255 170.473C428.255 170.473 428.255 170.554 428.174 170.554C427.691 170.956 427.208 171.76 428.657 172.162C431.314 172.966 433.648 171.197 432.602 170.634C431.877 170.232 431.716 169.106 431.636 168.544Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M433.084 171.036C432.923 170.795 432.44 170.071 431.635 170.634C430.749 171.278 430.588 172.001 430.669 172.564C430.749 173.207 432.52 172.725 432.601 172.645C432.601 172.564 433.084 171.036 433.084 171.036Z",
    fill: "#59595B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M432.199 120.779C432.199 128.981 432.279 138.228 432.279 145.385C432.279 153.587 432.923 163.799 432.843 170.715C431.555 172.323 428.174 171.921 427.449 170.715C426.564 164.443 424.632 154.954 425.115 148.119C423.022 139.113 420.446 128.418 421.251 121.342C423.263 121.985 430.267 120.136 432.199 120.779Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M434.533 87.5687C441.295 89.7399 442.905 96.2532 443.147 100.756C443.308 103.732 443.63 114.587 439.444 112.094C435.258 109.521 434.533 87.5687 434.533 87.5687Z",
    fill: "#59595B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M421.654 92.313C423.425 90.1419 427.692 87.0863 430.509 86.845C435.259 86.5234 439.042 90.4636 440.008 93.7605C440.893 96.8965 440.411 120.296 441.457 124.478C440.974 126.729 436.869 127.936 435.339 128.257C428.577 129.705 420.93 129.463 420.366 125.202C419.4 117.241 419.159 94.8058 421.654 92.313Z",
    fill: "url(#paint12_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M429.946 80.5727C429.785 79.0449 435.098 82.181 434.937 84.1913C434.776 85.8799 434.293 87.3273 435.983 88.3727C436.547 88.8552 438.559 92.0716 435.501 92.0716C431.154 92.1521 429.946 90.9459 426.807 88.2119C428.658 87.1665 430.51 85.5583 429.946 80.5727Z",
    fill: "#F6D3AF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M428.658 79.6078L430.832 76.5521H440.25V82.2614C440.25 85.3975 438.157 87.9706 435.501 87.9706C433.005 87.9706 430.59 85.8799 430.51 82.9047L429.383 82.5026L428.658 79.6078Z",
    fill: "#F6D3AF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M435.339 89.4986C433.085 89.4986 430.267 85.88 430.509 82.9048C430.589 85.7192 433.004 87.7295 435.339 87.9707C435.5 88.1316 435.661 88.212 435.902 88.3728C435.983 88.3728 435.983 88.4532 436.063 88.5336C436.063 88.9357 435.741 89.4986 435.339 89.4986Z",
    fill: "#EBC5A3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M439.767 74.0594C440.653 73.8986 440.733 73.1749 437.191 71.9687C435.179 71.0038 432.281 70.6821 430.429 71.8079C427.934 73.3357 427.129 75.6677 427.612 78.5625C428.095 81.4573 429.946 84.1913 429.946 84.1913C430.188 84.513 430.268 83.146 430.027 82.181C429.946 82.1006 429.785 81.779 429.705 81.3769C429.061 78.4821 430.832 78.8841 431.073 79.1254C431.637 79.3666 430.59 81.779 432.2 81.5377C433.005 81.4573 432.844 79.2058 432.844 78.4821C432.925 78.4821 433.086 78.5625 433.166 78.5625C434.535 79.2862 439.043 79.8491 436.547 78.2409C438.318 78.2409 440.733 79.045 441.538 77.9192C442.424 76.5522 440.894 75.1048 439.767 74.0594Z",
    fill: "#292929"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M224.189 144.5C224.189 149.003 221.049 154.471 217.105 156.723L93.539 227.968C89.675 230.22 86.4551 228.37 86.4551 223.867V131.393C86.4551 126.89 89.5945 121.422 93.539 119.171L217.105 47.9255C220.969 45.674 224.189 47.5235 224.189 52.0265V144.5Z",
    fill: "url(#paint13_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M270.717 152.622H238.276C230.467 152.622 220.968 154.471 217.104 156.723L93.5383 227.968C89.6744 230.22 92.8138 232.069 100.622 232.069H260.976C264.116 232.069 267.497 231.747 270.717 231.265V152.622Z",
    fill: "url(#paint14_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6775 209.554L95.2285 210.358V182.937L96.6775 182.133V209.554Z",
    fill: "#F1ECEC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M102.152 193.954L100.783 194.838V171.599L102.152 170.795V193.954Z",
    fill: "#59595B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M106.982 197.009L105.613 197.894V175.298L106.982 174.494V197.009Z",
    fill: "#F1ECEC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M113.261 203.925L111.812 204.729V189.049L113.261 188.245V203.925Z",
    fill: "#59595B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M118.816 194.999L117.367 195.803V169.589L118.816 168.785V194.999Z",
    fill: "#F1ECEC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M124.29 184.224L122.922 185.028V158.251L124.29 157.447V184.224Z",
    fill: "#59595B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M129.845 175.298L128.477 176.102V146.43L129.845 145.546V175.298Z",
    fill: "#F1ECEC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M135.398 191.139L133.949 191.943V150.773L135.398 149.968V191.139Z",
    fill: "#59595B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M204.87 123.03C204.87 126.166 204.226 129.544 203.179 132.841L209.458 132.68C210.987 128.096 211.873 123.432 211.873 119.01C211.873 103.329 200.845 96.9768 187.24 104.777V112.738C196.981 107.109 204.87 111.692 204.87 123.03Z",
    fill: "#F1ECEC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M203.179 132.841C200.362 141.364 194.244 149.647 187.16 153.667C177.339 159.296 169.45 154.713 169.45 143.455C169.45 132.197 177.42 118.447 187.16 112.818V104.857C173.556 112.738 162.527 131.795 162.527 147.476C162.527 163.156 173.556 169.508 187.16 161.708C196.981 156.08 205.433 144.581 209.378 132.68L203.179 132.841Z",
    fill: "#59595B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M154.396 92.0717C154.396 91.5089 154.799 90.7852 155.362 90.4635C155.845 90.1419 156.328 90.3831 156.328 91.0264C156.328 91.5893 155.926 92.313 155.362 92.6346C154.799 92.8759 154.396 92.6346 154.396 92.0717Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M160.191 88.6944C160.191 88.1315 160.594 87.4078 161.157 87.0862C161.64 86.7645 162.123 87.0058 162.123 87.6491C162.123 88.212 161.721 88.9357 161.157 89.2573C160.594 89.579 160.191 89.3377 160.191 88.6944Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M150.452 94.3233C150.452 93.7604 150.049 93.5191 149.486 93.7604C149.003 94.082 148.52 94.8057 148.52 95.3686C148.52 95.9315 148.922 96.1727 149.486 95.9315C150.049 95.6903 150.452 94.9666 150.452 94.3233Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M186.597 77.7584C162.17 91.8583 148.475 99.7636 124.049 113.863V112.657L186.597 76.5522V77.7584Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M186.597 81.6182L124.049 117.723V116.517L186.597 80.412V81.6182Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M176.613 91.2676L134.029 115.793V114.587L176.613 90.0614V91.2676Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M571.945 198.618C568.242 198.618 563.654 199.502 561.803 200.548L481.706 246.704L460.052 234.24C450.392 228.692 434.614 228.692 424.954 234.24L318.293 295.756C308.633 301.304 306.701 381.636 306.701 381.636H441.457C448.138 381.796 454.98 380.429 460.052 377.454L566.793 316.019C576.453 310.471 576.453 301.384 566.793 295.756L488.548 250.644L575.326 200.548C577.178 199.502 575.648 198.618 571.945 198.618Z",
    fill: "url(#paint15_linear)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M288.508 369.011V376.811L140.39 462.208L137.734 460.681L134.514 462.53L138.056 464.54C138.619 464.942 139.988 465.184 141.92 465.184C145.623 465.184 150.211 464.299 152.062 463.254L295.351 380.67L288.508 369.011Z",
    fill: "url(#paint16_linear)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M336.807 364.91C336.887 364.91 337.048 364.91 337.129 364.91L316.28 376.972C295.511 388.953 328.354 392.009 300.019 408.332C277.801 421.118 218.071 422.565 194.646 436.074C178.143 445.563 190.379 446.93 180.478 452.639C164.7 452.639 135.801 452.639 135.801 452.639L287.863 364.91H336.807Z",
    fill: "url(#paint17_linear)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M582.651 200.548L506.66 156.723L504.326 156.964L354.275 243.407L430.266 287.232L580.236 200.708C581.202 200.226 582.007 200.226 582.651 200.548Z",
    fill: "#F1ECEC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M437.029 283.452L500.221 247.026L485.328 238.422C475.669 232.873 459.891 232.873 450.231 238.422L404.588 264.716L437.029 283.452Z",
    fill: "url(#paint18_linear)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M580.235 200.789C582.087 199.743 583.616 200.548 583.616 202.719C583.616 204.89 582.087 207.463 580.235 208.589L430.266 295.032V287.232L580.235 200.789Z",
    fill: "#CACACB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M582.007 203.603C582.007 202.477 581.202 201.995 580.236 202.558C579.27 203.121 578.465 204.488 578.465 205.694C578.465 206.82 579.27 207.302 580.236 206.739C581.282 206.176 582.007 204.809 582.007 203.603Z",
    fill: "#59595B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M573.151 208.75C573.151 207.624 572.346 207.141 571.38 207.704C570.414 208.267 569.609 209.634 569.609 210.84C569.609 211.966 570.414 212.449 571.38 211.886C572.346 211.323 573.151 209.956 573.151 208.75Z",
    fill: "#59595B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M564.216 213.896C564.216 212.77 563.411 212.288 562.445 212.851C561.479 213.413 560.674 214.78 560.674 215.987C560.674 217.112 561.479 217.595 562.445 217.032C563.411 216.469 564.216 215.102 564.216 213.896Z",
    fill: "#59595B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M555.28 219.042C555.28 217.917 554.475 217.434 553.509 217.997C552.543 218.56 551.738 219.927 551.738 221.053C551.738 222.178 552.543 222.661 553.509 222.098C554.475 221.616 555.28 220.248 555.28 219.042Z",
    fill: "#59595B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M546.347 224.269C546.347 223.143 545.542 222.661 544.576 223.224C543.61 223.787 542.805 225.154 542.805 226.279C542.805 227.405 543.61 227.888 544.576 227.325C545.542 226.762 546.347 225.395 546.347 224.269Z",
    fill: "#59595B"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M537.411 229.415C537.411 228.29 536.606 227.807 535.64 228.37C534.674 228.933 533.869 230.3 533.869 231.506C533.869 232.632 534.674 233.114 535.64 232.552C536.606 231.908 537.411 230.541 537.411 229.415Z",
    fill: "#59595B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M528.476 234.562C528.476 233.436 527.671 232.954 526.705 233.516C525.739 234.079 524.934 235.446 524.934 236.653C524.934 237.859 525.739 238.261 526.705 237.698C527.671 237.055 528.476 235.688 528.476 234.562Z",
    fill: "#59595B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M519.54 239.708C519.54 238.582 518.735 238.1 517.769 238.663C516.803 239.226 515.998 240.593 515.998 241.719C515.998 242.844 516.803 243.327 517.769 242.764C518.735 242.201 519.54 240.834 519.54 239.708Z",
    fill: "#59595B"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M510.604 244.855C510.604 243.729 509.799 243.246 508.833 243.809C507.867 244.372 507.062 245.739 507.062 246.865C507.062 247.991 507.867 248.473 508.833 247.91C509.799 247.347 510.604 245.98 510.604 244.855Z",
    fill: "#59595B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M501.669 250.001C501.669 248.875 500.864 248.393 499.898 248.956C498.932 249.518 498.127 250.885 498.127 252.092C498.127 253.217 498.932 253.7 499.898 253.137C500.864 252.494 501.669 251.127 501.669 250.001Z",
    fill: "#59595B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M492.733 255.147C492.733 254.022 491.928 253.539 490.962 254.102C489.996 254.665 489.191 256.032 489.191 257.158C489.191 258.283 489.996 258.766 490.962 258.203C491.928 257.64 492.733 256.273 492.733 255.147Z",
    fill: "#59595B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M483.798 260.294C483.798 259.168 482.993 258.685 482.027 259.248C481.061 259.811 480.256 261.178 480.256 262.304C480.256 263.43 481.061 263.912 482.027 263.349C482.993 262.786 483.798 261.419 483.798 260.294Z",
    fill: "#59595B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M474.862 265.44C474.862 264.314 474.057 263.832 473.091 264.395C472.125 264.958 471.32 266.325 471.32 267.531C471.32 268.657 472.125 269.139 473.091 268.576C474.138 267.933 474.862 266.566 474.862 265.44Z",
    fill: "#59595B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M466.009 270.586C466.009 269.461 465.204 268.978 464.238 269.541C463.272 270.104 462.467 271.471 462.467 272.677C462.467 273.803 463.272 274.285 464.238 273.723C465.204 273.079 466.009 271.712 466.009 270.586Z",
    fill: "#59595B"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M457.073 275.733C457.073 274.607 456.268 274.124 455.302 274.687C454.336 275.25 453.531 276.617 453.531 277.743C453.531 278.869 454.336 279.351 455.302 278.788C456.268 278.226 457.073 276.859 457.073 275.733Z",
    fill: "#59595B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M448.138 280.879C448.138 279.753 447.333 279.271 446.367 279.834C445.401 280.397 444.596 281.764 444.596 282.889C444.596 284.015 445.401 284.498 446.367 283.935C447.333 283.372 448.138 282.005 448.138 280.879Z",
    fill: "#59595B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M439.202 286.026C439.202 284.9 438.397 284.417 437.431 284.98C436.465 285.543 435.66 286.91 435.66 288.116C435.66 289.322 436.465 289.725 437.431 289.162C438.397 288.518 439.202 287.151 439.202 286.026Z",
    fill: "#59595B"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M497.805 160.663L495.793 161.869L571.784 205.694L573.796 204.488L497.805 160.663ZM474.621 174.012L550.612 217.836L552.625 216.63L476.634 172.886L474.621 174.012ZM453.45 186.234L529.441 230.059L531.454 228.853L455.463 185.028L453.45 186.234ZM432.279 198.457L508.27 242.281L510.282 241.075L434.291 197.251L432.279 198.457ZM411.188 210.599L487.179 254.424L489.192 253.217L413.201 209.393L411.188 210.599ZM390.017 222.822L466.008 266.646L468.02 265.44L392.029 221.616L390.017 222.822ZM368.846 235.044L444.837 278.869L446.849 277.663L370.858 233.838L368.846 235.044Z",
    fill: "url(#paint19_linear)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M445.561 224.51C455.221 230.059 455.221 239.226 445.561 244.774L338.9 306.209C329.24 311.757 313.462 311.757 303.802 306.209L197.221 244.694C187.562 239.145 187.562 229.978 197.221 224.43L303.883 162.915C313.543 157.366 329.32 157.366 338.98 162.915L445.561 224.51Z",
    fill: "url(#paint20_linear)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M445.562 224.51L429.623 215.263L401.126 237.537L366.914 271.953H398.389L445.642 244.694C455.221 239.145 455.221 230.059 445.562 224.51Z",
    fill: "#CACACB"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M445.561 244.694L338.9 306.209C329.24 311.757 313.462 311.757 303.802 306.209L197.221 244.694C192.392 241.879 189.977 238.261 189.977 234.562V314.009C189.977 317.708 192.392 321.326 197.221 324.141L303.883 385.656C313.543 391.205 329.32 391.205 338.98 385.656L445.641 324.141C450.471 321.407 452.806 317.708 452.886 314.089V234.642C452.806 238.341 450.391 241.96 445.561 244.694Z",
    fill: "url(#paint21_linear)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M303.803 385.656C305.574 386.701 307.506 387.506 309.599 388.149L288.508 346.093V376.891L303.803 385.656Z",
    fill: "#F1ECEC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M281.745 317.145L219.197 281.121C215.495 278.949 212.436 280.718 212.436 284.98V332.986L288.427 376.811V328.805C288.507 324.463 285.529 319.236 281.745 317.145Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M288.508 328.805C288.508 324.543 285.449 319.316 281.746 317.145L254.135 301.223L62.547 411.709C60.6955 412.755 59.166 415.408 59.166 417.58C59.166 418.786 59.649 419.59 60.454 419.912L135.962 463.495L138.619 455.614L288.588 369.091V328.805H288.508Z",
    fill: "#F1ECEC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M138.537 455.534C136.686 456.579 135.156 459.233 135.156 461.404C135.156 463.575 136.686 464.46 138.537 463.334L288.507 376.811V369.011L138.537 455.534Z",
    fill: "#CACACB"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M136.768 460.439C136.768 459.313 137.573 457.946 138.539 457.303C139.505 456.74 140.31 457.223 140.31 458.348C140.31 459.474 139.505 460.841 138.539 461.404C137.573 462.047 136.768 461.565 136.768 460.439Z",
    fill: "#59595B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M145.621 455.293C145.621 454.167 146.426 452.8 147.392 452.237C148.358 451.674 149.163 452.157 149.163 453.283C149.163 454.408 148.358 455.775 147.392 456.419C146.426 456.901 145.621 456.419 145.621 455.293Z",
    fill: "#59595B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M154.557 450.146C154.557 449.021 155.362 447.654 156.328 447.091C157.294 446.528 158.099 447.01 158.099 448.136C158.099 449.262 157.294 450.629 156.328 451.272C155.362 451.755 154.557 451.272 154.557 450.146Z",
    fill: "#59595B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M163.492 445C163.492 443.874 164.297 442.507 165.263 441.944C166.229 441.382 167.034 441.864 167.034 442.99C167.034 444.116 166.229 445.483 165.263 446.045C164.297 446.608 163.492 446.126 163.492 445Z",
    fill: "#59595B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M172.428 439.854C172.428 438.728 173.233 437.361 174.199 436.718C175.165 436.155 175.97 436.637 175.97 437.763C175.97 438.889 175.165 440.256 174.199 440.819C173.233 441.462 172.428 440.979 172.428 439.854Z",
    fill: "#59595B"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M181.363 434.707C181.363 433.581 182.168 432.215 183.134 431.652C184.1 431.089 184.905 431.571 184.905 432.697C184.905 433.823 184.1 435.19 183.134 435.833C182.168 436.316 181.363 435.833 181.363 434.707Z",
    fill: "#59595B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M190.299 429.561C190.299 428.435 191.104 427.068 192.07 426.505C193.036 425.942 193.841 426.425 193.841 427.551C193.841 428.677 193.036 430.044 192.07 430.606C191.104 431.169 190.299 430.687 190.299 429.561Z",
    fill: "#59595B"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M199.234 424.415C199.234 423.289 200.039 421.922 201.005 421.279C201.971 420.716 202.776 421.198 202.776 422.324C202.776 423.45 201.971 424.817 201.005 425.38C200.039 426.023 199.234 425.54 199.234 424.415Z",
    fill: "#59595B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M208.17 419.268C208.17 418.142 208.975 416.775 209.941 416.213C210.907 415.65 211.712 416.132 211.712 417.258C211.712 418.384 210.907 419.751 209.941 420.394C208.975 420.876 208.17 420.394 208.17 419.268Z",
    fill: "#59595B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M217.105 414.122C217.105 412.996 217.91 411.629 218.876 411.066C219.842 410.503 220.647 410.986 220.647 412.112C220.647 413.237 219.842 414.604 218.876 415.167C217.91 415.73 217.105 415.248 217.105 414.122Z",
    fill: "#59595B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M226.041 408.975C226.041 407.85 226.846 406.483 227.812 405.839C228.778 405.277 229.583 405.759 229.583 406.885C229.583 408.011 228.778 409.378 227.812 409.94C226.846 410.584 226.041 410.101 226.041 408.975Z",
    fill: "#59595B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M234.977 403.829C234.977 402.703 235.782 401.336 236.748 400.693C237.714 400.13 238.519 400.613 238.519 401.738C238.519 402.864 237.714 404.231 236.748 404.794C235.782 405.437 234.977 404.955 234.977 403.829Z",
    fill: "#59595B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M243.912 398.683C243.912 397.557 244.717 396.19 245.683 395.627C246.649 395.064 247.454 395.547 247.454 396.672C247.454 397.798 246.649 399.165 245.683 399.809C244.717 400.291 243.912 399.808 243.912 398.683Z",
    fill: "#59595B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M252.766 393.536C252.766 392.411 253.571 391.044 254.537 390.481C255.503 389.918 256.308 390.4 256.308 391.526C256.308 392.652 255.503 394.019 254.537 394.582C253.571 395.145 252.766 394.662 252.766 393.536Z",
    fill: "#59595B"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M261.701 388.39C261.701 387.264 262.506 385.897 263.472 385.254C264.438 384.691 265.243 385.173 265.243 386.299C265.243 387.425 264.438 388.792 263.472 389.355C262.506 389.998 261.701 389.516 261.701 388.39Z",
    fill: "#59595B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M270.637 383.244C270.637 382.118 271.442 380.751 272.408 380.188C273.374 379.625 274.179 380.108 274.179 381.233C274.179 382.359 273.374 383.726 272.408 384.369C271.442 384.852 270.637 384.369 270.637 383.244Z",
    fill: "#59595B"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M279.572 378.097C279.572 376.971 280.377 375.604 281.343 374.961C282.309 374.398 283.114 374.881 283.114 376.007C283.114 377.132 282.309 378.499 281.343 379.062C280.377 379.705 279.572 379.223 279.572 378.097Z",
    fill: "#59595B"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M100.221 389.918L176.213 433.742L178.225 432.536L102.234 388.792L100.221 389.918ZM79.0502 402.141L155.041 445.965L157.054 444.759L81.0627 400.934L79.0502 402.141ZM59.7305 415.087L135.722 458.911C136.044 458.188 136.446 457.544 136.929 456.981L60.938 413.157C60.3745 413.72 59.972 414.363 59.7305 415.087ZM227.168 316.743L288.589 352.124V349.792L229.261 315.537L227.168 316.743ZM287.865 325.025L250.352 303.395L248.34 304.601L288.509 327.759C288.348 326.875 288.187 325.91 287.865 325.025ZM163.655 353.33L239.646 397.155L241.658 395.949L165.748 352.205L163.655 353.33ZM184.826 341.188L260.817 385.013L262.829 383.807L186.838 339.982L184.826 341.188ZM205.997 328.966L281.988 372.79L284.001 371.584L208.01 327.759L205.997 328.966ZM121.393 377.776L197.384 421.6L199.396 420.394L123.405 376.569L121.393 377.776ZM142.564 365.553L218.555 409.378L220.567 408.171L144.576 364.347L142.564 365.553Z",
    fill: "url(#paint22_linear)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M443.709 266.325L444.917 265.601V253.378L443.709 254.102V266.325Z",
    fill: "#1E1C6B"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M440.168 268.335L441.456 267.611V255.389L440.168 256.112V268.335Z",
    fill: "#1E1C6B"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M436.707 270.345L437.915 269.621V257.399L436.707 258.123V270.345Z",
    fill: "#1E1C6B"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M433.244 272.355L434.452 271.632V259.409L433.244 260.133V272.355Z",
    fill: "#1E1C6B"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M429.703 274.366L430.991 273.642V261.419L429.703 262.143V274.366Z",
    fill: "#1E1C6B"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M281.746 317.145L267.417 308.863L249.869 318.994C223.062 334.434 213.886 297.927 185.63 312.24C163.413 323.417 160.998 342.153 137.492 355.662C120.99 365.151 118.655 354.054 108.754 359.763C108.754 368.85 108.754 428.837 108.754 428.837L287.945 325.508C286.979 322.05 284.564 318.753 281.746 317.145Z",
    fill: "#292929"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0625 412.835L108.754 428.837C108.754 412.916 108.754 364.267 108.754 359.763L81.0625 343.761C81.0625 352.848 81.0625 412.835 81.0625 412.835Z",
    fill: "#292929"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M239.726 292.861L222.177 302.993C195.371 318.432 186.194 281.925 157.939 296.238C135.721 307.415 133.306 326.151 109.801 339.66C93.2983 349.149 90.9639 338.052 81.0625 343.761L108.754 359.763C118.656 354.054 120.99 365.151 137.492 355.662C160.998 342.153 163.413 323.417 185.631 312.24C213.886 298.007 223.063 334.514 249.869 318.995L267.418 308.863L239.726 292.861Z",
    fill: "#313131"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M288.508 328.805C288.508 328.724 288.508 328.644 288.508 328.644L267.659 340.706C246.89 352.687 241.658 333.71 213.322 350.114C191.104 362.9 188.689 397.316 165.183 410.906C148.681 420.394 146.347 413.398 136.445 419.108C136.445 428.194 136.445 444.92 136.445 444.92L288.508 357.029V328.805Z",
    fill: "#C0162E"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M108.754 428.757L136.446 444.759V418.947L108.754 402.945C108.754 412.112 108.754 428.757 108.754 428.757Z",
    fill: "#C0162E"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M281.746 317.145L267.417 308.863L239.967 324.704C219.199 336.685 213.966 317.708 185.63 334.112C163.413 346.898 160.998 381.314 137.492 394.904C120.99 404.392 118.655 397.396 108.754 403.106L136.446 419.108C146.347 413.398 148.681 420.394 165.184 410.906C188.689 397.396 191.104 362.9 213.322 350.114C241.658 333.79 246.89 352.687 267.659 340.706L288.508 328.644C288.428 324.382 285.449 319.236 281.746 317.145Z",
    fill: "url(#paint23_linear)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M157.214 444.759L288.508 369.011V357.029L136.445 444.759C136.445 444.759 146.025 444.759 157.214 444.759Z",
    fill: "url(#paint24_linear)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M165.183 410.825C171.623 407.126 176.453 401.899 180.559 395.949C182.491 381.233 185.63 367.805 186.757 360.97C188.528 349.712 197.785 343.199 204.145 340.062C220.969 331.78 226.041 338.293 235.378 333.871C243.348 330.011 243.992 324.623 248.58 319.879L240.047 324.784C219.279 336.766 214.046 317.788 185.711 334.192C163.493 346.978 161.078 381.394 137.572 394.984C121.07 404.473 118.735 397.477 108.834 403.186C120.989 403.186 147.474 413.559 160.434 413.479C161.883 412.594 163.412 411.79 165.183 410.825Z",
    fill: "url(#paint25_linear)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8335 335.801L81.0625 336.846V332.263L82.8335 331.217V335.801Z",
    fill: "#59595B"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1581 334.112L88.3066 335.157V330.654L90.1581 329.609V334.112Z",
    fill: "#59595B"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4042 335.801L95.5527 336.846V332.263L97.4042 331.217V335.801Z",
    fill: "#59595B"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M104.648 334.836L102.797 335.881V331.298L104.648 330.252V334.836Z",
    fill: "#59595B"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M111.894 331.7L110.043 332.745V328.161L111.894 327.116V331.7Z",
    fill: "#59595B"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M119.138 326.392L117.367 327.438V322.854L119.138 321.809V326.392Z",
    fill: "#59595B"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M126.384 319.397L124.613 320.442V315.858L126.384 314.813V319.397Z",
    fill: "#59595B"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M133.628 311.677L131.857 312.722V308.139L133.628 307.094V311.677Z",
    fill: "#59595B"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M140.955 302.59L139.104 303.636V299.052L140.955 298.007V302.59Z",
    fill: "#59595B"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M148.199 295.997L146.348 297.042V292.459L148.199 291.413V295.997Z",
    fill: "#59595B"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M155.443 291.011L153.592 292.057V287.473L155.443 286.428V291.011Z",
    fill: "#59595B"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M162.689 287.312L160.918 288.358V283.774L162.689 282.729V287.312Z",
    fill: "#59595B"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M169.933 285.382L168.162 286.428V281.844L169.933 280.799V285.382Z",
    fill: "#59595B"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M177.179 286.267L175.408 287.312V282.729L177.179 281.683V286.267Z",
    fill: "#59595B"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M184.423 289.081L182.652 290.127V285.543L184.423 284.498V289.081Z",
    fill: "#59595B"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M191.75 293.343L189.898 294.388V289.805L191.75 288.76V293.343Z",
    fill: "#59595B"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M198.994 296.64L197.143 297.685V293.102L198.994 292.057V296.64Z",
    fill: "#59595B"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M206.238 299.454L204.387 300.5V295.916L206.238 294.871V299.454Z",
    fill: "#59595B"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4736 348.506L64.7207 355.26V353.17L76.4736 346.415V348.506Z",
    fill: "#59595B"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4741 356.949L70.5977 360.407V358.236L76.4741 354.778V356.949Z",
    fill: "#59595B"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4736 365.312L64.7207 372.067V369.895L76.4736 363.141V365.312Z",
    fill: "#59595B"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4741 373.675L70.5977 377.132V375.042L76.4741 371.504V373.675Z",
    fill: "#59595B"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4736 382.038L64.7207 388.792V386.621L76.4736 379.866V382.038Z",
    fill: "#59595B"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4741 390.4L70.5977 393.858V391.767L76.4741 388.31V390.4Z",
    fill: "#59595B"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4736 398.763L64.7207 405.518V403.427L76.4736 396.672V398.763Z",
    fill: "#59595B"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4741 407.126L70.5977 410.584V408.493L76.4741 405.035V407.126Z",
    fill: "#59595B"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4736 415.489L64.7207 422.244V420.153L76.4736 413.398V415.489Z",
    fill: "#59595B"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M469.872 195.723H449.828L462.547 203.04L449.828 210.438H469.872L482.591 203.04L469.872 195.723Z",
    fill: "url(#paint26_linear)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M449.828 210.438L462.547 203.04V188.405L449.828 195.723V210.438Z",
    fill: "#292929"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M449.828 210.438L437.109 203.04V188.405L449.828 195.723V210.438Z",
    fill: "#CACACB"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M449.828 195.723L437.109 188.405L449.828 181.088L462.547 188.405L449.828 195.723Z",
    fill: "#C0162E"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M479.292 238.261H467.619L475.025 242.523L467.619 246.785H479.292L486.697 242.523L479.292 238.261Z",
    fill: "url(#paint27_linear)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M467.619 246.785L475.025 242.523V233.999L467.619 238.261V246.785Z",
    fill: "#292929"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M467.619 246.785L460.213 242.523V233.999L467.619 238.261V246.785Z",
    fill: "#313131"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M467.619 238.261L460.213 233.999L467.619 229.737L475.025 233.999L467.619 238.261Z",
    fill: "#CACACB"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M548.439 208.348H567.196L580.236 200.789C581.122 200.226 582.007 200.226 582.571 200.548L562.446 188.968H548.439V208.348Z",
    fill: "url(#paint28_linear)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M548.44 188.807L531.535 179.078L548.44 169.348L565.345 179.078L548.44 188.807Z",
    fill: "#F1ECEC"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M548.44 208.348L531.535 198.537V179.078L548.44 188.807V208.348Z",
    fill: "#59595B"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M548.439 208.348L565.344 198.537V179.078L548.439 188.807V208.348Z",
    fill: "#CACACB"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M548.439 172.564L547.07 171.76L548.439 171.036L549.807 171.76L548.439 172.564Z",
    fill: "#59595B"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M551.579 174.414L550.211 173.61L551.579 172.805L552.948 173.61L551.579 174.414Z",
    fill: "#59595B"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M554.718 176.183L553.43 175.459L554.718 174.655L556.086 175.459L554.718 176.183Z",
    fill: "#59595B"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M557.939 178.032L556.57 177.228L557.939 176.504L559.227 177.228L557.939 178.032Z",
    fill: "#59595B"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M561.077 179.882L559.709 179.078L561.077 178.273L562.365 179.078L561.077 179.882Z",
    fill: "#59595B"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M545.3 174.414L543.932 173.61L545.3 172.805L546.669 173.61L545.3 174.414Z",
    fill: "#59595B"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M548.439 176.183L547.07 175.459L548.439 174.655L549.807 175.459L548.439 176.183Z",
    fill: "#59595B"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M551.579 178.032L550.211 177.228L551.579 176.504L552.948 177.228L551.579 178.032Z",
    fill: "#59595B"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M554.718 179.882L553.43 179.078L554.718 178.273L556.086 179.078L554.718 179.882Z",
    fill: "#59595B"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M557.939 181.651L556.57 180.847L557.939 180.123L559.227 180.847L557.939 181.651Z",
    fill: "#59595B"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M542.161 176.183L540.793 175.459L542.161 174.655L543.53 175.459L542.161 176.183Z",
    fill: "#59595B"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M545.3 178.032L543.932 177.228L545.3 176.504L546.669 177.228L545.3 178.032Z",
    fill: "#59595B"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M548.439 179.882L547.07 179.078L548.439 178.273L549.807 179.078L548.439 179.882Z",
    fill: "#59595B"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M551.579 181.651L550.211 180.847L551.579 180.123L552.948 180.847L551.579 181.651Z",
    fill: "#59595B"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M554.718 183.5L553.43 182.696L554.718 181.892L556.086 182.696L554.718 183.5Z",
    fill: "#59595B"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M539.023 178.032L537.654 177.228L539.023 176.504L540.391 177.228L539.023 178.032Z",
    fill: "#59595B"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M542.161 179.882L540.793 179.078L542.161 178.273L543.53 179.078L542.161 179.882Z",
    fill: "#59595B"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M545.3 181.651L543.932 180.847L545.3 180.123L546.669 180.847L545.3 181.651Z",
    fill: "#59595B"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M548.439 183.5L547.07 182.696L548.439 181.892L549.807 182.696L548.439 183.5Z",
    fill: "#59595B"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M551.579 185.269L550.211 184.546L551.579 183.741L552.948 184.546L551.579 185.269Z",
    fill: "#59595B"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M535.882 179.882L534.514 179.078L535.882 178.273L537.251 179.078L535.882 179.882Z",
    fill: "#59595B"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M539.023 181.651L537.654 180.847L539.023 180.123L540.391 180.847L539.023 181.651Z",
    fill: "#59595B"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M542.161 183.5L540.793 182.696L542.161 181.892L543.53 182.696L542.161 183.5Z",
    fill: "#59595B"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M545.3 185.269L543.932 184.546L545.3 183.741L546.669 184.546L545.3 185.269Z",
    fill: "#59595B"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M548.439 187.119L547.07 186.315L548.439 185.51L549.807 186.315L548.439 187.119Z",
    fill: "#59595B"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M534.352 183.983L533.064 183.179V181.651L534.352 182.374V183.983Z",
    fill: "#59595B"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M537.491 185.752L536.203 185.028V183.42L537.491 184.224V185.752Z",
    fill: "#59595B"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M540.712 187.601L539.344 186.797V185.269L540.712 186.073V187.601Z",
    fill: "#59595B"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M543.851 189.37L542.482 188.647V187.038L543.851 187.842V189.37Z",
    fill: "#59595B"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M546.992 191.22L545.623 190.416V188.888L546.992 189.692V191.22Z",
    fill: "#59595B"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M534.352 187.601L533.064 186.797V185.269L534.352 186.073V187.601Z",
    fill: "#59595B"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M537.491 189.37L536.203 188.647V187.038L537.491 187.842V189.37Z",
    fill: "#59595B"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M540.712 191.22L539.344 190.416V188.888L540.712 189.692V191.22Z",
    fill: "#59595B"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M543.851 193.069L542.482 192.265V190.737L543.851 191.461V193.069Z",
    fill: "#59595B"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M546.992 194.838L545.623 194.115V192.506L546.992 193.31V194.838Z",
    fill: "#59595B"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M534.352 191.22L533.064 190.416V188.888L534.352 189.692V191.22Z",
    fill: "#59595B"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M537.491 193.069L536.203 192.265V190.737L537.491 191.461V193.069Z",
    fill: "#59595B"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M540.712 194.838L539.344 194.115V192.506L540.712 193.31V194.838Z",
    fill: "#59595B"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M543.851 196.688L542.482 195.884V194.356L543.851 195.08V196.688Z",
    fill: "#59595B"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M546.992 198.457L545.623 197.733V196.125L546.992 196.929V198.457Z",
    fill: "#59595B"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M534.352 194.838L533.064 194.115V192.506L534.352 193.31V194.838Z",
    fill: "#59595B"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M537.491 196.688L536.203 195.884V194.356L537.491 195.08V196.688Z",
    fill: "#59595B"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M540.712 198.457L539.344 197.733V196.125L540.712 196.929V198.457Z",
    fill: "#59595B"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M543.851 200.306L542.482 199.502V197.974L543.851 198.778V200.306Z",
    fill: "#59595B"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M546.992 202.156L545.623 201.352V199.744L546.992 200.548V202.156Z",
    fill: "#59595B"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M534.352 198.457L533.064 197.733V196.125L534.352 196.929V198.457Z",
    fill: "#59595B"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M537.491 200.306L536.203 199.502V197.974L537.491 198.778V200.306Z",
    fill: "#59595B"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M540.712 202.156L539.344 201.352V199.744L540.712 200.548V202.156Z",
    fill: "#59595B"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M543.851 203.925L542.482 203.121V201.593L543.851 202.397V203.925Z",
    fill: "#59595B"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M546.992 205.774L545.623 204.97V203.442L546.992 204.166V205.774Z",
    fill: "#59595B"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M562.527 183.983L563.896 183.179V181.651L562.527 182.374V183.983Z",
    fill: "#59595B"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M559.389 185.752L560.757 185.028V183.42L559.389 184.224V185.752Z",
    fill: "#59595B"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M556.248 187.601L557.617 186.797V185.269L556.248 186.073V187.601Z",
    fill: "#59595B"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M553.109 189.37L554.397 188.647V187.038L553.109 187.842V189.37Z",
    fill: "#59595B"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M549.969 191.22L551.257 190.416V188.888L549.969 189.692V191.22Z",
    fill: "#59595B"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M562.527 187.601L563.896 186.797V185.269L562.527 186.073V187.601Z",
    fill: "#59595B"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M559.389 189.37L560.757 188.647V187.038L559.389 187.842V189.37Z",
    fill: "#59595B"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M556.248 191.22L557.617 190.416V188.888L556.248 189.692V191.22Z",
    fill: "#59595B"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M553.109 193.069L554.397 192.265V190.737L553.109 191.461V193.069Z",
    fill: "#59595B"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M549.969 194.838L551.257 194.115V192.506L549.969 193.31V194.838Z",
    fill: "#59595B"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M562.527 191.22L563.896 190.416V188.888L562.527 189.692V191.22Z",
    fill: "#59595B"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M559.389 193.069L560.757 192.265V190.737L559.389 191.461V193.069Z",
    fill: "#59595B"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M556.248 194.838L557.617 194.115V192.506L556.248 193.31V194.838Z",
    fill: "#59595B"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M553.109 196.688L554.397 195.884V194.356L553.109 195.08V196.688Z",
    fill: "#59595B"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M549.969 198.457L551.257 197.733V196.125L549.969 196.929V198.457Z",
    fill: "#59595B"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M562.527 194.838L563.896 194.115V192.506L562.527 193.31V194.838Z",
    fill: "#59595B"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M559.389 196.688L560.757 195.884V194.356L559.389 195.08V196.688Z",
    fill: "#59595B"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M556.248 198.457L557.617 197.733V196.125L556.248 196.929V198.457Z",
    fill: "#59595B"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M553.109 200.306L554.397 199.502V197.974L553.109 198.778V200.306Z",
    fill: "#59595B"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M549.969 202.156L551.257 201.352V199.744L549.969 200.548V202.156Z",
    fill: "#59595B"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M562.527 198.457L563.896 197.733V196.125L562.527 196.929V198.457Z",
    fill: "#59595B"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M559.389 200.306L560.757 199.502V197.974L559.389 198.778V200.306Z",
    fill: "#59595B"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M556.248 202.156L557.617 201.352V199.744L556.248 200.548V202.156Z",
    fill: "#59595B"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M553.109 203.925L554.397 203.121V201.593L553.109 202.397V203.925Z",
    fill: "#59595B"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M549.969 205.774L551.257 204.97V203.442L549.969 204.166V205.774Z",
    fill: "#59595B"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M555.524 205.614H543.852L551.257 209.875L543.852 214.137H555.524L562.93 209.875L555.524 205.614Z",
    fill: "url(#paint29_linear)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M543.852 214.137L551.258 209.875V201.352L543.852 205.614V214.137Z",
    fill: "#292929"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M543.851 214.137L536.445 209.875V201.352L543.851 205.614V214.137Z",
    fill: "#313131"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M543.851 205.614L536.445 201.352L543.851 197.09L551.257 201.352L543.851 205.614Z",
    fill: "#CACACB"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M503.2 198.859C499.899 196.929 499.899 193.793 503.2 191.863L508.915 188.566C512.216 186.636 517.69 186.636 520.99 188.566C524.291 190.496 524.291 193.632 520.99 195.562L515.275 198.859C511.974 200.789 506.581 200.789 503.2 198.859ZM517.77 190.496C516.241 189.612 513.745 189.612 512.135 190.496L506.42 193.793C504.89 194.678 504.89 196.125 506.42 197.01C507.949 197.894 510.445 197.894 512.055 197.01L517.77 193.713C519.38 192.828 519.38 191.381 517.77 190.496Z",
    fill: "url(#paint30_linear)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M499.979 195.401C496.679 193.471 496.679 190.335 499.979 188.405L505.695 185.109C508.995 183.179 514.469 183.179 517.77 185.109C521.07 187.038 521.07 190.174 517.77 192.104L512.054 195.401C508.754 197.331 503.28 197.331 499.979 195.401ZM514.55 186.958C513.02 186.073 510.525 186.073 508.915 186.958L503.199 190.255C501.67 191.139 501.67 192.587 503.199 193.471C504.729 194.356 507.224 194.356 508.834 193.471L514.55 190.175C516.079 189.29 516.079 187.843 514.55 186.958Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M514.55 186.958C513.021 186.074 510.525 186.074 508.915 186.958L503.2 190.255C501.67 191.14 501.67 192.587 503.2 193.471C503.28 193.552 503.361 193.552 503.441 193.632L508.915 190.496C510.364 189.692 512.699 189.612 514.228 190.335L514.47 190.175C516.08 189.29 516.08 187.843 514.55 186.958Z",
    fill: "#59595B"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M517.77 192.104L512.055 195.401C508.754 197.331 503.28 197.331 499.98 195.401C498.289 194.436 497.484 193.23 497.484 191.944V195.401C497.484 196.688 498.289 197.975 499.98 198.939C503.28 200.869 508.754 200.869 512.055 198.939L517.77 195.643C519.461 194.678 520.266 193.391 520.266 192.185V188.647C520.266 189.853 519.461 191.139 517.77 192.104Z",
    fill: "#59595B"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M435.338 358.236L397.986 379.786V333.147L435.338 311.677V358.236Z",
    fill: "#CACACB"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M373.596 306.289L397.987 333.147V379.786L373.596 365.634V306.289Z",
    fill: "#59595B"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M373.596 306.289C386.073 299.133 398.47 291.896 410.947 284.739C419.078 293.665 427.208 302.671 435.419 311.597C422.942 318.753 410.545 325.99 398.067 333.147C389.856 324.221 381.726 315.215 373.596 306.289Z",
    fill: "url(#paint31_linear)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M383.416 306.209C385.428 305.083 386.394 304.52 388.407 303.395C394.283 309.827 400.16 316.341 406.036 322.774C404.024 323.9 403.058 324.462 401.045 325.588C395.169 319.155 389.292 312.642 383.416 306.209Z",
    fill: "url(#paint32_linear)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M399.999 301.063L401.045 302.188L391.546 315.135L390.5 314.009L399.999 301.063Z",
    fill: "url(#paint33_linear)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M400.804 302.59L402.253 301.706L392.03 315.698L391.547 315.135L400.804 302.59Z",
    fill: "url(#paint34_linear)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M398.469 300.982C398.469 299.535 399.676 298.328 401.125 298.328C402.574 298.328 403.782 299.535 403.782 300.982C403.782 302.43 402.574 303.636 401.125 303.636C399.676 303.636 398.469 302.43 398.469 300.982Z",
    fill: "url(#paint35_radial)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M281.826 281.12L284.161 282.407L311.289 266.807V264.154L281.826 281.12Z",
    fill: "#292929"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M311.289 264.154V266.807L313.543 265.44L311.289 264.154Z",
    fill: "#59595B"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M276.354 277.904L278.688 279.271L305.816 263.591V261.017L276.354 277.904Z",
    fill: "#292929"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M305.816 261.017V263.591L308.07 262.304L305.816 261.017Z",
    fill: "#59595B"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M270.879 274.768L273.213 276.135L300.342 260.455V257.801L270.879 274.768Z",
    fill: "#292929"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M300.342 257.801V260.455L302.596 259.168L300.342 257.801Z",
    fill: "#59595B"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M265.404 271.632L267.658 272.918L294.786 257.319V254.665L265.404 271.632Z",
    fill: "#292929"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M294.787 254.665V257.319L297.122 255.951L294.787 254.665Z",
    fill: "#59595B"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M259.932 268.496L262.186 269.782L289.314 254.102V251.529L259.932 268.496Z",
    fill: "#292929"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M289.314 251.529V254.102L291.649 252.815L289.314 251.529Z",
    fill: "#59595B"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M254.457 265.279L256.711 266.646L283.839 250.966V248.312L254.457 265.279Z",
    fill: "#292929"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M283.84 248.312V250.966L286.174 249.679L283.84 248.312Z",
    fill: "#59595B"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M248.982 262.143L251.236 263.43L278.365 247.83V245.176L248.982 262.143Z",
    fill: "#292929"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M278.365 245.176V247.83L280.619 246.463L278.365 245.176Z",
    fill: "#59595B"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M243.51 259.007L245.764 260.294L272.892 244.613V242.04L243.51 259.007Z",
    fill: "#292929"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M272.893 242.04V244.613L275.147 243.327L272.893 242.04Z",
    fill: "#59595B"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M238.035 255.791L240.289 257.158L267.417 241.477V238.824L238.035 255.791Z",
    fill: "#292929"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M267.418 238.824V241.477L269.672 240.191L267.418 238.824Z",
    fill: "#59595B"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M427.046 209.393L372.79 240.673C368.926 242.925 362.647 242.925 358.864 240.673L259.448 183.339C257.516 182.214 256.55 180.766 256.55 179.319V208.83C256.469 210.358 257.435 211.805 259.448 212.931L358.783 270.265C362.647 272.516 368.926 272.516 372.71 270.265L426.966 238.985C428.898 237.859 429.864 236.331 429.864 234.884V205.292C429.944 206.82 428.978 208.267 427.046 209.393Z",
    fill: "url(#paint36_linear)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M372.79 238.743C368.926 240.995 362.647 240.995 358.864 238.743L251.478 176.826C247.614 174.575 247.614 171.036 251.478 168.785L313.784 132.841C317.648 130.589 323.927 130.589 327.711 132.841L435.096 194.758C438.96 197.01 438.96 200.548 435.096 202.799L372.79 238.743Z",
    fill: "url(#paint37_linear)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M435.096 202.799L372.79 238.743C368.926 240.995 362.647 240.995 358.864 238.743L251.478 176.826C249.546 175.7 248.58 174.253 248.58 172.806V179.319C248.58 180.766 249.546 182.214 251.478 183.34L358.864 245.257C362.728 247.508 369.007 247.508 372.79 245.257L435.096 209.313C437.028 208.187 437.994 206.739 437.994 205.292V198.698C437.994 200.226 437.028 201.673 435.096 202.799Z",
    fill: "url(#paint38_linear)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M317.891 233.999C317.891 233.275 318.374 233.034 318.937 233.356C319.501 233.678 319.984 234.562 319.984 235.205C319.984 235.929 319.501 236.17 318.937 235.849C318.374 235.527 317.891 234.723 317.891 233.999Z",
    fill: "#59595B"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M323.445 237.055C323.445 236.09 324.17 235.688 324.975 236.17C325.86 236.653 326.504 237.859 326.504 238.824C326.504 239.789 325.78 240.191 324.975 239.708C324.17 239.226 323.445 238.1 323.445 237.055Z",
    fill: "#59595B"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M329.482 240.432C329.482 239.467 330.207 239.065 331.012 239.548C331.897 240.03 332.541 241.236 332.541 242.201C332.541 243.166 331.817 243.568 331.012 243.086C330.126 242.603 329.482 241.397 329.482 240.432Z",
    fill: "#59595B"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M347.353 268.496H342.442C342.201 268.254 341.879 267.933 341.476 267.772C340.269 267.129 338.739 266.727 337.21 266.807H335.6V266.968C334.715 267.129 333.829 267.37 333.185 267.772C332.058 268.415 331.414 269.3 331.414 270.184C331.414 271.069 331.978 271.953 333.185 272.597C333.91 272.999 334.715 273.24 335.6 273.401V273.562H337.371C338.9 273.562 340.43 273.24 341.557 272.597C341.879 272.355 342.201 272.195 342.442 271.953H347.433V268.496H347.353Z",
    fill: "url(#paint39_linear)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M339.705 270.586C337.371 271.953 333.668 271.953 331.333 270.586C330.207 269.943 329.562 269.059 329.562 268.174V270.184C329.562 271.069 330.126 271.953 331.333 272.597C333.668 273.964 337.371 273.964 339.705 272.597C340.832 271.953 341.476 271.069 341.476 270.184V268.174C341.476 269.059 340.832 269.943 339.705 270.586Z",
    fill: "#CACACB"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M335.519 271.551C333.99 271.551 332.46 271.23 331.333 270.586C330.207 269.943 329.562 269.059 329.562 268.174C329.562 267.29 330.126 266.405 331.333 265.762C333.668 264.395 337.371 264.395 339.705 265.762C340.832 266.405 341.476 267.29 341.476 268.174C341.476 269.059 340.913 269.943 339.705 270.586C338.578 271.23 337.049 271.551 335.519 271.551Z",
    fill: "#59595B"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M335.52 269.943H340.591C341.155 269.38 341.477 268.817 341.477 268.174C341.477 267.611 341.235 267.048 340.752 266.566H335.52V269.943Z",
    fill: "url(#paint40_linear)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M351.056 249.84L349.366 247.428L349.044 248.232C347.031 247.186 345.502 247.91 345.502 250.162C345.502 251.368 345.985 252.896 346.709 254.182L346.629 254.504L347.997 255.871C348.4 256.353 348.883 256.756 349.366 256.997C351.459 258.203 353.149 256.997 353.149 254.584C352.988 252.896 352.183 251.127 351.056 249.84Z",
    fill: "#F1ECEC"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M344.375 255.147C342.282 253.941 340.592 250.725 340.592 248.312C340.592 245.9 342.282 245.257 344.375 246.463C346.468 247.669 348.159 250.323 348.159 252.735C348.159 255.147 346.468 256.353 344.375 255.147Z",
    fill: "#59595B"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M347.996 253.941L346.145 250.242L342.361 253.217C342.925 254.022 343.649 254.745 344.374 255.147C346.064 256.193 347.513 255.549 347.996 253.941Z",
    fill: "#59595B"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M346.548 251.931C346.548 250.564 345.582 248.956 344.375 248.312C343.731 247.991 343.248 247.91 342.845 248.071L333.99 253.137C333.024 253.7 332.461 254.745 332.461 255.791V268.094C332.461 268.576 332.783 268.978 333.346 269.38C333.99 269.702 334.715 269.863 335.52 269.863C336.325 269.863 337.13 269.702 337.693 269.38C338.337 269.059 338.579 268.576 338.579 268.094V257.56L345.904 253.378C345.904 253.378 345.985 253.378 345.985 253.298C346.307 253.057 346.548 252.574 346.548 251.931Z",
    fill: "#313131"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M350.653 251.288C350.653 248.875 348.962 246.222 346.869 245.015C345.742 244.372 344.776 244.292 344.132 244.694L341.637 246.141C342.361 245.739 343.327 245.9 344.374 246.463C346.467 247.669 348.157 250.323 348.157 252.735C348.157 254.022 347.674 254.906 346.95 255.389L349.445 253.941C350.17 253.539 350.653 252.574 350.653 251.288Z",
    fill: "#CACACB"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M274.34 173.208L315.073 149.727C318.132 147.958 323.122 147.958 326.262 149.727L412.074 199.261C412.798 199.663 413.362 200.146 413.684 200.628C414.891 198.939 414.408 196.929 412.074 195.562L326.262 146.028C323.203 144.259 318.212 144.259 315.073 146.028L274.34 169.509C272.006 170.876 271.442 172.886 272.73 174.575C273.052 174.092 273.616 173.61 274.34 173.208Z",
    fill: "url(#paint41_linear)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M274.34 176.022L360.152 225.556C363.211 227.325 368.202 227.325 371.342 225.556L412.074 202.076C412.799 201.674 413.362 201.191 413.684 200.709C413.282 200.226 412.718 199.744 412.074 199.342L326.262 149.808C323.203 148.039 318.212 148.039 315.073 149.808L274.34 173.288C273.616 173.69 273.052 174.173 272.73 174.655C273.052 175.138 273.616 175.62 274.34 176.022Z",
    fill: "url(#paint42_linear)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M274.34 176.022L360.152 225.556C363.211 227.325 368.202 227.325 371.342 225.556L412.074 202.076C412.799 201.674 413.362 201.191 413.684 200.709C413.282 200.226 412.718 199.744 412.074 199.342L326.262 149.808C323.203 148.039 318.212 148.039 315.073 149.808L274.34 173.288C273.616 173.69 273.052 174.173 272.73 174.655C273.052 175.138 273.616 175.62 274.34 176.022Z",
    fill: "url(#paint43_linear)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M285.852 142.41C285.852 139.837 287.945 137.746 290.52 137.746C293.096 137.746 295.189 139.837 295.189 142.41C295.189 144.983 293.096 147.074 290.52 147.074C287.945 147.074 285.852 144.983 285.852 142.41Z",
    fill: "#292929"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M378.184 186.073C378.184 182.616 381.001 179.721 384.543 179.721C388.004 179.721 390.902 182.535 390.902 186.073C390.902 189.531 388.085 192.426 384.543 192.426C381.001 192.426 378.184 189.531 378.184 186.073Z",
    fill: "#292929"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M335.439 156.723C335.439 153.265 338.257 150.371 341.799 150.371C345.26 150.371 348.158 153.185 348.158 156.723C348.158 160.181 345.341 163.076 341.799 163.076C338.257 162.995 335.439 160.181 335.439 156.723Z",
    fill: "#292929"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M380.92 117.241C380.92 115.15 382.61 113.542 384.623 113.542C386.716 113.542 388.326 115.23 388.326 117.241C388.326 119.331 386.635 120.94 384.623 120.94C382.61 120.94 380.92 119.251 380.92 117.241Z",
    fill: "url(#paint44_linear)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M402.254 168.383C402.254 166.292 403.944 164.684 405.957 164.684C408.05 164.684 409.66 166.372 409.66 168.383C409.66 170.473 407.969 172.082 405.957 172.082C403.944 172.082 402.254 170.473 402.254 168.383Z",
    fill: "#292929"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M322.721 121.101C322.721 119.01 324.411 117.402 326.424 117.402C328.436 117.402 330.127 119.09 330.127 121.101C330.127 123.191 328.436 124.8 326.424 124.8C324.411 124.8 322.721 123.111 322.721 121.101Z",
    fill: "url(#paint45_linear)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M335.279 99.3089C335.279 96.012 337.936 93.278 341.317 93.278C344.617 93.278 347.354 95.9316 347.354 99.3089C347.354 102.606 344.698 105.34 341.317 105.34C337.936 105.259 335.279 102.606 335.279 99.3089Z",
    fill: "url(#paint46_linear)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M312.658 160.824C312.658 158.733 314.349 157.125 316.361 157.125C318.454 157.125 320.064 158.814 320.064 160.824C320.064 162.915 318.374 164.523 316.361 164.523C314.268 164.603 312.658 162.915 312.658 160.824Z",
    fill: "#292929"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M339.303 197.653C339.303 195.562 340.993 193.954 343.006 193.954C345.099 193.954 346.709 195.643 346.709 197.653C346.709 199.744 345.018 201.352 343.006 201.352C340.993 201.432 339.303 199.744 339.303 197.653Z",
    fill: "#292929"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M375.77 82.1811C375.77 80.8141 376.897 79.6884 378.265 79.6884C379.634 79.6884 380.76 80.8141 380.76 82.1811C380.76 83.5481 379.634 84.6739 378.265 84.6739C376.897 84.6739 375.77 83.5481 375.77 82.1811Z",
    fill: "url(#paint47_linear)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M403.461 127.775C403.461 126.729 404.266 125.925 405.312 125.925C406.359 125.925 407.164 126.729 407.164 127.775C407.164 128.82 406.359 129.624 405.312 129.624C404.346 129.624 403.461 128.74 403.461 127.775Z",
    fill: "url(#paint48_linear)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M397.021 92.0718C397.021 91.0264 397.826 90.2223 398.873 90.2223C399.919 90.2223 400.724 91.0264 400.724 92.0718C400.724 93.1171 399.919 93.9212 398.873 93.9212C397.826 93.9212 397.021 93.1171 397.021 92.0718Z",
    fill: "url(#paint49_linear)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M388.971 188.647C388.971 187.601 389.776 186.797 390.822 186.797C391.869 186.797 392.674 187.601 392.674 188.647C392.674 189.692 391.869 190.496 390.822 190.496C389.856 190.496 388.971 189.612 388.971 188.647Z",
    fill: "#292929"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M368.766 150.853C368.766 149.808 369.571 149.004 370.617 149.004C371.664 149.004 372.469 149.808 372.469 150.853C372.469 151.898 371.664 152.702 370.617 152.702C369.651 152.702 368.766 151.818 368.766 150.853Z",
    fill: "#292929"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M277.238 118.929C277.238 117.16 278.607 115.793 280.378 115.793C282.149 115.793 283.517 117.16 283.517 118.929C283.517 120.698 282.149 122.065 280.378 122.065C278.607 122.065 277.238 120.618 277.238 118.929Z",
    fill: "url(#paint50_linear)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M395.17 140.56C395.17 139.515 395.975 138.711 397.021 138.711C398.068 138.711 398.873 139.515 398.873 140.56C398.873 141.606 398.068 142.41 397.021 142.41C395.975 142.41 395.17 141.606 395.17 140.56Z",
    fill: "#292929"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M296.559 67.8678C296.559 66.8224 297.364 66.0183 298.41 66.0183C299.457 66.0183 300.262 66.8224 300.262 67.8678C300.262 68.9131 299.457 69.7173 298.41 69.7173C297.364 69.7173 296.559 68.9131 296.559 67.8678Z",
    fill: "url(#paint51_linear)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M362.406 181.088C362.406 180.043 363.211 179.238 364.258 179.238C365.304 179.238 366.109 180.043 366.109 181.088C366.109 182.133 365.304 182.937 364.258 182.937C363.211 182.937 362.406 182.133 362.406 181.088Z",
    fill: "#292929"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M330.609 177.228C330.609 176.183 331.414 175.379 332.461 175.379C333.507 175.379 334.312 176.183 334.312 177.228C334.312 178.273 333.507 179.078 332.461 179.078C331.414 179.078 330.609 178.273 330.609 177.228Z",
    fill: "#292929"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M367.799 20.7463C367.799 19.701 368.604 18.8969 369.65 18.8969C370.697 18.8969 371.502 19.701 371.502 20.7463C371.502 21.7917 370.697 22.5958 369.65 22.5958C368.604 22.5958 367.799 21.7917 367.799 20.7463Z",
    fill: "url(#paint52_linear)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M352.021 61.0328C352.021 59.4245 353.309 58.1379 354.919 58.1379C356.529 58.1379 357.817 59.4245 357.817 61.0328C357.817 62.641 356.529 63.9276 354.919 63.9276C353.309 63.9276 352.021 62.641 352.021 61.0328Z",
    fill: "url(#paint53_linear)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M300.744 178.274C300.744 177.228 301.549 176.424 302.596 176.424C303.642 176.424 304.447 177.228 304.447 178.274C304.447 179.319 303.642 180.123 302.596 180.123C301.549 180.123 300.744 179.319 300.744 178.274Z",
    fill: "#292929"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M358.381 207.946C358.381 206.9 359.186 206.096 360.232 206.096C361.279 206.096 362.084 206.9 362.084 207.946C362.084 208.991 361.279 209.795 360.232 209.795C359.186 209.795 358.381 208.91 358.381 207.946Z",
    fill: "#292929"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M378.908 48.006C378.908 46.9606 379.713 46.1565 380.76 46.1565C381.806 46.1565 382.611 46.9606 382.611 48.006C382.611 49.0513 381.806 49.8554 380.76 49.8554C379.713 49.8554 378.908 48.9709 378.908 48.006Z",
    fill: "url(#paint54_linear)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M333.426 46.1565C333.426 45.1111 334.231 44.307 335.277 44.307C336.324 44.307 337.129 45.1111 337.129 46.1565C337.129 47.2018 336.324 48.006 335.277 48.006C334.231 48.006 333.426 47.1214 333.426 46.1565Z",
    fill: "url(#paint55_linear)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M565.587 350.677H559.469L562.769 352.607L545.623 362.497H551.66L568.887 352.607L565.587 350.677Z",
    fill: "url(#paint56_linear)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M545.623 358.959L542.322 357.11L556.249 349.069L553.914 347.702L557.134 345.852L562.769 349.069L545.623 358.959Z",
    fill: "url(#paint57_linear)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M545.623 362.497L542.322 360.648V357.11L545.623 358.959V362.497Z",
    fill: "#F1ECEC"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M553.914 350.436V347.702L556.249 349.069L553.914 350.436Z",
    fill: "#F1ECEC"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M562.93 352.526L545.783 362.417V358.879L562.93 348.988V352.526Z",
    fill: "#59595B"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6497 393.215H27.5318L30.7518 395.064L13.6055 404.955H19.7234L36.8697 395.064L33.6497 393.215Z",
    fill: "url(#paint58_linear)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6047 401.417L10.3848 399.567L24.3111 391.526L21.8961 390.159L25.1966 388.31L30.751 391.526L13.6047 401.417Z",
    fill: "#313131"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6047 404.955L10.3848 403.105V399.567L13.6047 401.417V404.955Z",
    fill: "#292929"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8965 392.893V390.159L24.3115 391.526L21.8965 392.893Z",
    fill: "#292929"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7518 395.064L13.6055 404.955V401.417L30.7518 391.526V395.064Z",
    fill: "black"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M507.064 138.952H500.946L504.166 140.882L487.02 150.772H493.137L510.284 140.882L507.064 138.952Z",
    fill: "url(#paint59_linear)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M487.019 147.234L483.799 145.385L497.725 137.344L495.31 135.977L498.611 134.127L504.165 137.344L487.019 147.234Z",
    fill: "#292929"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M487.019 150.772L483.799 148.843V145.385L487.019 147.234V150.772Z",
    fill: "#313131"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M495.311 138.711V135.977L497.726 137.344L495.311 138.711Z",
    fill: "#313131"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M504.166 140.882L487.02 150.772V147.234L504.166 137.344V140.882Z",
    fill: "black"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M500.844 370.699C497.544 368.769 497.544 365.633 500.844 363.704L506.56 360.407C509.86 358.477 515.334 358.477 518.635 360.407C521.935 362.337 521.935 365.473 518.635 367.402L512.919 370.699C509.619 372.629 504.145 372.629 500.844 370.699ZM515.415 362.256C513.885 361.372 511.39 361.372 509.78 362.256L504.064 365.553C502.535 366.438 502.535 367.885 504.064 368.769C505.594 369.654 508.089 369.654 509.699 368.769L515.415 365.473C516.944 364.588 516.944 363.141 515.415 362.256Z",
    fill: "#F1ECEC"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M497.544 367.161C494.243 365.231 494.243 362.095 497.544 360.165L503.259 356.869C506.56 354.939 512.034 354.939 515.334 356.869C518.634 358.798 518.634 361.935 515.334 363.864L509.619 367.161C506.318 369.091 500.925 369.091 497.544 367.161ZM512.114 358.718C510.585 357.834 508.089 357.834 506.479 358.718L500.764 362.015C499.234 362.9 499.234 364.347 500.764 365.231C502.293 366.116 504.789 366.116 506.399 365.231L512.114 361.935C513.724 361.05 513.724 359.603 512.114 358.718Z",
    fill: "#F7F7FC"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M512.115 358.718C510.585 357.833 508.09 357.833 506.48 358.718L500.764 362.015C499.235 362.899 499.235 364.347 500.764 365.231C500.845 365.312 500.925 365.312 501.006 365.392L506.48 362.256C507.929 361.452 510.263 361.372 511.793 362.095L512.034 361.934C513.725 361.05 513.725 359.603 512.115 358.718Z",
    fill: "#59595B"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M515.415 363.864L509.699 367.161C506.399 369.091 500.925 369.091 497.624 367.161C495.934 366.196 495.129 364.99 495.129 363.704V367.161C495.129 368.448 495.934 369.735 497.624 370.699C500.925 372.629 506.399 372.629 509.699 370.699L515.415 367.403C517.105 366.438 517.91 365.151 517.91 363.945V360.407C517.91 361.613 517.025 362.9 515.415 363.864Z",
    fill: "#59595B"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M455.543 380.268H422.297V386.38H455.543V380.268Z",
    fill: "url(#paint60_linear)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M470.598 371.423H437.352V377.534H470.598V371.423Z",
    fill: "url(#paint61_linear)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M439.846 328.805C438.96 329.931 437.511 330.976 437.028 331.7C436.626 332.423 436.304 333.549 436.304 333.951C436.223 334.353 436.304 335.64 436.867 335.479C437.431 335.399 437.511 335.881 438.075 335.881C438.638 335.881 438.477 335.64 438.477 335.64C438.719 335.801 439.121 335.881 439.202 335.64C439.443 335.72 439.524 336.042 439.926 335.64C440.329 335.318 440.49 334.675 440.812 334.353C441.778 333.308 442.019 329.689 442.261 329.368C442.422 329.046 440.49 328.081 439.846 328.805Z",
    fill: "#F6D3AF"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M438.801 299.937C445.643 306.772 445.885 320.201 442.423 330.252C440.974 331.78 438.559 330.494 439.123 328.966C442.101 317.306 442.504 306.209 438.801 299.937Z",
    fill: "#292929"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M440.973 375.605C440.973 370.78 437.914 370.699 437.914 370.699C437.914 370.699 436.304 370.699 433.567 369.574C430.911 368.448 427.208 368.93 429.301 372.71C429.301 372.79 429.381 372.79 429.381 372.871C429.542 373.112 429.703 373.273 430.025 373.433L436.707 377.293C437.753 377.937 440.973 376.65 440.973 375.605Z",
    fill: "#C0162E"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M440.972 375.202C440.892 376.167 437.752 377.534 436.706 376.891L430.025 373.031C429.783 372.87 429.461 372.629 429.059 372.388C429.139 372.549 429.139 372.629 429.22 372.79C429.22 372.87 429.3 372.87 429.3 372.951C429.461 373.192 429.622 373.353 429.944 373.514L436.626 377.374C437.591 377.936 440.489 376.811 440.811 375.846C440.811 375.765 440.811 375.685 440.811 375.685C440.972 375.444 440.972 375.363 440.972 375.202Z",
    fill: "black"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M439.765 370.056C438.96 370.056 436.223 370.78 436.223 370.78C436.223 370.78 436.223 371.182 435.982 371.504L435.901 371.584C435.338 371.986 434.774 372.549 436.062 373.353C437.109 373.996 437.994 373.594 438.396 373.192C438.557 372.871 438.799 372.549 439.121 372.308C439.443 372.147 439.685 371.986 439.846 371.986V371.906C439.846 371.906 440.087 370.056 439.765 370.056Z",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M439.846 323.176C436.868 323.256 429.301 323.337 426.322 323.417C427.449 332.423 429.703 340.625 431.233 349.39C432.843 357.914 434.694 363.864 436.224 370.941C436.787 372.227 439.444 371.745 440.007 370.458C440.41 363.945 440.893 355.984 438.961 348.506C439.283 340.384 440.007 331.298 439.846 323.176Z",
    fill: "black"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M425.84 384.45C425.84 379.625 422.782 379.545 422.782 379.545C422.782 379.545 421.172 379.545 418.435 378.419C415.778 377.293 412.075 377.776 414.168 381.555C414.168 381.635 414.249 381.635 414.249 381.716C414.41 381.957 414.571 382.118 414.893 382.279L421.574 386.138C422.621 386.782 425.84 385.415 425.84 384.45Z",
    fill: "#C0162E"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M425.84 384.048C425.759 385.013 422.62 386.38 421.573 385.736L414.892 381.877C414.65 381.716 414.328 381.475 413.926 381.153C414.006 381.314 414.006 381.394 414.087 381.555C414.087 381.635 414.167 381.635 414.167 381.716C414.328 381.957 414.489 382.118 414.811 382.279L421.493 386.138C422.459 386.701 425.357 385.576 425.679 384.611C425.679 384.53 425.679 384.45 425.679 384.45C425.84 384.289 425.84 384.128 425.84 384.048Z",
    fill: "black"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M424.634 378.901C423.829 378.901 421.092 379.625 421.092 379.625C421.092 379.625 421.092 380.027 420.851 380.349L420.77 380.429C420.207 380.831 419.643 381.394 420.931 382.198C421.978 382.842 422.863 382.44 423.266 382.037C423.427 381.716 423.668 381.394 423.99 381.153C424.312 380.992 424.554 380.831 424.715 380.831V380.751C424.715 380.751 424.956 378.901 424.634 378.901Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M430.269 344.646C431.074 340.786 440.573 340.304 439.929 325.025C436.95 324.623 421.977 331.619 418.999 331.217C418.596 340.304 419.482 348.747 419.562 357.673C419.804 366.357 420.609 372.549 421.011 379.786C421.333 381.153 424.07 381.153 424.795 379.947C426.244 373.594 428.015 365.794 427.371 358.075C428.256 353.732 429.303 349.149 430.269 344.646Z",
    fill: "black"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M433.568 333.63C427.128 337.248 420.366 337.248 418.112 332.825C418.997 324.543 416.341 305.646 418.112 303.555C419.078 302.51 422.217 298.57 428.657 298.57C433.165 298.57 439.122 297.605 440.571 302.59C442.101 306.933 442.423 315.054 440.088 324.543C439.364 329.046 436.788 331.86 433.568 333.63Z",
    fill: "black"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M426.403 299.294C428.335 297.927 428.013 295.112 427.933 293.263C427.691 292.217 427.53 291.172 427.691 289.966C428.094 285.784 431.072 282.407 434.292 282.97C440.813 284.015 439.283 287.393 438.961 291.494C438.639 295.353 436.627 297.846 433.648 298.007C433.568 298.65 434.212 298.65 434.856 298.892C435.5 302.269 429.543 301.867 428.335 301.304C426.886 300.661 425.518 300.178 426.403 299.294Z",
    fill: "#F6D3AF"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M436.868 280.96C436.707 280.397 435.741 280.075 432.28 281.281C432.28 281.281 431.475 281.603 431.394 281.603C425.035 284.176 426.403 291.413 427.289 293.423C427.611 294.147 427.852 294.63 427.691 295.675C430.187 295.675 430.911 297.042 432.521 295.675C433.648 294.71 435.419 293.584 435.741 293.102C436.063 292.619 435.983 292.298 435.983 291.896C436.063 288.438 437.593 290.609 437.593 291.413C438.237 291.091 438.237 289.724 438.237 288.197C443.711 284.337 440.893 281.522 436.868 280.96Z",
    fill: "#F2C94C"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M400.241 304.52C399.839 305.083 398.631 303.797 398.39 303.314L398.631 302.993C398.39 302.912 397.665 302.993 397.102 303.314C396.297 303.716 396.136 304.279 395.572 305.646C394.848 307.335 397.585 308.139 398.068 308.863L400.885 307.013C400.885 307.013 401.207 306.048 401.207 305.325C401.127 304.601 400.644 303.877 400.241 304.52Z",
    fill: "#F6D3AF"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M418.997 302.51C415.616 306.289 411.43 311.275 408.21 314.009C405.634 311.757 402.494 308.38 401.528 306.933C399.275 305.566 397.584 308.219 398.309 309.667C399.355 311.677 403.702 318.592 406.68 320.764C409.498 322.774 414.811 320.522 418.353 315.778C421.331 310.953 422.78 299.776 418.997 302.51Z",
    fill: "#292929"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M543.287 263.751H514.951V269.702H543.287V263.751Z",
    fill: "url(#paint62_linear)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M530.569 272.356H500.141V278.306H530.569V272.356Z",
    fill: "url(#paint63_linear)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M477.68 208.026C477.841 207.302 479.37 206.579 480.98 206.418C480.658 206.096 480.256 205.533 480.417 205.372C480.658 205.131 482.59 206.177 483.234 206.82C483.717 207.141 484.12 207.463 484.764 207.624L485.005 210.599C485.005 210.599 482.751 210.76 481.785 210.197C480.819 209.634 479.29 210.036 478.404 210.438C478.082 210.76 477.438 208.75 477.68 208.026Z",
    fill: "#F6D3AF"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M484.683 210.84C484.683 210.84 482.912 209.634 484.925 207.624C491.364 207.061 496.033 202.96 497.321 195.964C497.804 192.989 500.944 193.069 500.944 197.09C500.944 203.845 495.792 211.484 484.683 210.84Z",
    fill: "#313131"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M518.332 267.852C518.332 263.189 515.354 263.108 515.354 263.108C515.354 263.108 513.744 263.269 511.087 262.304C507.787 261.098 504.969 261.42 506.982 265.118C506.982 265.199 507.062 265.199 507.062 265.279C507.223 265.44 507.384 265.681 507.706 265.842L514.146 269.622C515.193 270.104 518.332 268.817 518.332 267.852Z",
    fill: "#C0162E"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M518.333 267.45C518.253 268.415 515.194 269.702 514.228 269.139L507.788 265.36C507.546 265.199 507.224 264.958 506.902 264.716C506.983 264.877 506.983 264.958 507.063 265.118C507.063 265.199 507.144 265.199 507.144 265.279C507.305 265.44 507.466 265.681 507.788 265.842L514.228 269.622C515.113 270.184 517.931 269.059 518.333 268.094C518.333 268.013 518.333 267.933 518.333 267.933C518.333 267.692 518.333 267.611 518.333 267.45Z",
    fill: "black"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M517.205 262.465C516.803 262.465 515.917 262.626 515.193 262.786C514.549 262.626 512.456 262.545 511.087 262.143C510.685 262.063 510.282 261.741 509.88 262.063C509.316 262.706 510.765 264.314 513.663 265.601C514.71 266.244 515.515 265.842 515.917 265.44C516.078 265.118 516.32 264.797 516.642 264.636C516.964 264.475 517.205 264.314 517.366 264.314V264.234C517.366 264.234 517.447 262.465 517.205 262.465Z",
    fill: "#F6D3AF"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M515.676 231.908C516.964 227.968 518.171 223.385 517.205 218.801C514.307 218.882 506.982 217.193 504.084 217.273C505.13 226.038 507.626 233.758 509.075 242.201C510.604 250.403 512.536 256.514 514.066 263.349C514.629 264.636 517.366 264.073 517.366 263.269C517.769 256.916 517.527 249.599 515.595 242.362C515.756 238.985 515.193 235.205 515.676 231.908Z",
    fill: "#292929"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M503.681 276.457C503.681 271.793 500.703 271.712 500.703 271.712C500.703 271.712 499.012 271.793 496.356 270.828C493.055 269.622 490.318 270.024 492.331 273.723C492.331 273.803 492.411 273.803 492.411 273.883C492.572 274.044 492.733 274.286 493.055 274.446L499.495 278.226C500.542 278.708 503.681 277.341 503.681 276.457Z",
    fill: "#C0162E"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M503.681 275.974C503.6 276.939 500.541 278.226 499.575 277.663L493.135 273.883C492.894 273.723 492.572 273.481 492.25 273.24C492.33 273.401 492.331 273.481 492.411 273.642C492.411 273.723 492.491 273.723 492.491 273.803C492.652 273.964 492.813 274.205 493.135 274.366L499.575 278.145C500.461 278.708 503.278 277.582 503.681 276.617C503.681 276.537 503.681 276.457 503.681 276.457C503.681 276.296 503.681 276.135 503.681 275.974Z",
    fill: "black"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M502.475 270.988C502.072 270.988 501.187 271.149 500.462 271.31C499.818 271.149 497.725 271.069 496.357 270.667C495.954 270.586 495.552 270.265 495.149 270.586C494.586 271.23 496.035 272.838 498.933 274.125C499.979 274.768 500.784 274.366 501.187 273.964C501.348 273.642 501.589 273.32 501.911 273.16C502.233 272.999 502.475 272.838 502.636 272.838V272.758C502.636 272.758 502.797 270.988 502.475 270.988Z",
    fill: "#F6D3AF"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M507.948 237.778C510.443 227.807 517.93 233.517 517.286 218.721C514.388 218.319 502.232 224.752 499.334 224.35C497.644 235.044 497.966 241.719 498.046 250.323C498.207 258.686 498.771 264.475 499.173 271.471C499.495 272.838 502.554 272.758 502.554 271.873C504.003 265.681 505.13 258.203 504.486 250.725C505.452 246.624 507.062 242.201 507.948 237.778Z",
    fill: "#292929"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M513.985 234.16C509.316 237.055 501.91 238.824 497.161 236.733C496.678 233.919 500.944 215.665 498.127 210.84C497.483 209.795 495.712 210.519 494.988 209.473C493.297 207.302 490.641 200.306 490.641 199.341C490.641 197.331 492.251 195.321 493.861 194.195C496.115 192.667 499.335 190.657 502.152 191.22C508.35 192.989 516.722 206.659 518.896 227.486C518.493 229.576 516.803 232.391 513.985 234.16Z",
    fill: "black"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M500.22 191.22C498.047 190.416 497.966 189.451 497.724 187.601C497.805 186.556 497.725 185.511 497.403 184.465C496.276 180.605 492.814 177.871 489.836 178.997C483.798 181.168 485.811 184.063 486.938 188.003C487.984 191.622 490.319 193.632 493.217 193.23C493.378 193.793 493.378 194.436 492.734 195.16C495.068 195.803 498.127 194.356 499.334 193.552C500.381 192.667 501.266 191.863 500.22 191.22Z",
    fill: "#F6D3AF"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M480.499 221.374L486.617 214.218L483.397 205.453L477.359 212.529L480.499 221.374Z",
    fill: "#59595B"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M480.498 221.374L471.321 219.686L468.182 210.84L477.359 212.529L480.498 221.374Z",
    fill: "#CACACB"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M477.359 212.529L468.182 210.84L474.219 203.764L483.396 205.453L477.359 212.529Z",
    fill: "#C0162E"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M476.554 217.997C475.991 218.158 475.347 216.871 474.461 216.952C473.576 217.032 471.563 217.032 471.724 217.595C471.805 218.077 473.495 217.675 473.254 217.917C472.771 218.721 471.08 218.319 470.597 217.836C470.114 217.354 469.551 217.354 469.712 217.917C469.873 218.479 470.678 221.133 473.012 221.294C475.266 221.535 477.762 220.651 477.762 220.651L476.554 217.997Z",
    fill: "#F6D3AF"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M476.956 221.133C476.956 221.133 474.783 220.249 476.151 217.756C482.189 215.504 490.158 207.785 490.561 199.1C491.124 195.643 494.747 196.688 494.747 200.95C494.827 207.704 487.904 218.801 476.956 221.133Z",
    fill: "black"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M485.489 185.671C485.006 183.339 485.972 179.078 490.077 178.354C494.102 177.63 496.437 180.043 497.322 183.42C498.047 186.073 502.313 193.069 508.19 191.139C506.821 196.527 488.628 201.915 485.489 185.671Z",
    fill: "#F2C94C"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M193.512 232.214H162.129V237.976H193.512V232.214Z",
    fill: "url(#paint64_linear)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M207.688 223.912H176.305V229.674H207.688V223.912Z",
    fill: "url(#paint65_linear)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M179.825 227.916C179.825 223.424 176.99 223.229 176.99 223.229C176.99 223.229 175.426 223.229 172.884 222.154C170.44 221.08 166.92 221.568 168.875 225.182C168.875 225.182 168.875 225.28 168.973 225.28C169.071 225.475 169.266 225.67 169.658 225.866L175.915 229.577C176.697 230.065 179.728 228.795 179.825 227.916Z",
    fill: "#AE2C34"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M179.727 227.428C179.63 228.405 176.697 229.577 175.719 229.088L169.462 225.377C169.266 225.279 168.875 224.986 168.582 224.693C168.68 224.791 168.68 224.889 168.778 225.084C168.778 225.084 168.778 225.182 168.875 225.182C168.973 225.377 169.169 225.572 169.56 225.768L175.817 229.479C176.697 229.967 179.434 228.893 179.825 228.014C179.825 227.916 179.825 227.916 179.825 227.819C179.825 227.721 179.727 227.623 179.727 227.428Z",
    fill: "url(#paint66_linear)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M178.652 222.643C177.87 222.643 175.328 223.326 175.328 223.326C175.328 223.326 175.328 223.717 175.133 224.01C175.133 224.01 175.133 224.108 175.035 224.108C174.546 224.498 173.959 224.987 175.23 225.768C176.208 226.354 176.99 225.963 177.381 225.573C177.577 225.28 177.772 224.987 178.066 224.791C178.359 224.596 178.554 224.498 178.75 224.498V224.401C178.75 224.401 178.946 222.643 178.652 222.643Z",
    fill: "white"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M178.651 178.402C175.816 178.5 168.777 178.598 165.941 178.598C167.017 187.094 169.07 194.809 170.536 203.111C172.101 211.119 173.763 216.783 175.229 223.424C175.816 224.694 178.26 224.205 178.749 223.033C179.14 216.881 179.629 209.459 177.771 202.329C178.162 194.614 178.847 186.118 178.651 178.402Z",
    fill: "black"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M165.452 236.218C165.452 231.725 162.617 231.53 162.617 231.53C162.617 231.53 161.053 231.53 158.511 230.456C156.067 229.382 152.547 229.87 154.502 233.483C154.502 233.483 154.502 233.581 154.6 233.581C154.698 233.776 154.893 233.972 155.284 234.167L161.542 237.878C162.421 238.366 165.452 237.097 165.452 236.218Z",
    fill: "#AE2C34"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M165.452 235.827C165.354 236.804 162.421 237.976 161.444 237.487L155.187 233.776C154.991 233.679 154.6 233.386 154.307 233.093C154.404 233.19 154.404 233.288 154.502 233.483C154.502 233.483 154.502 233.581 154.6 233.581C154.698 233.776 154.893 233.972 155.284 234.167L161.541 237.878C162.421 238.366 165.159 237.292 165.55 236.413C165.55 236.315 165.55 236.315 165.55 236.218C165.452 236.022 165.452 235.925 165.452 235.827Z",
    fill: "url(#paint67_linear)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M164.279 230.944C163.497 230.944 160.955 231.628 160.955 231.628C160.955 231.628 160.955 232.019 160.76 232.312C160.76 232.312 160.76 232.409 160.662 232.409C160.173 232.8 159.586 233.288 160.857 234.07C161.835 234.656 162.617 234.265 163.008 233.874C163.204 233.581 163.399 233.288 163.693 233.093C163.986 232.898 164.181 232.8 164.377 232.8V232.702C164.377 232.702 164.67 230.944 164.279 230.944Z",
    fill: "white"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M169.655 198.618C170.437 195.005 179.334 194.517 178.748 180.161C175.912 179.77 161.834 186.411 158.999 185.923C158.608 194.517 159.487 202.427 159.487 210.826C159.683 218.932 160.465 224.792 160.856 231.628C161.15 232.897 163.789 232.897 164.474 231.823C165.842 225.866 167.504 218.541 166.918 211.217C167.798 207.213 168.775 202.916 169.655 198.618Z",
    fill: "black"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M172.297 153.987C182.269 160.628 183.442 173.91 178.065 182.309C178.065 182.309 179.238 163.656 172.297 153.987Z",
    fill: "url(#paint68_linear)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M173.567 208.971C167.505 212.389 158.12 209.85 155.773 204.967C156.556 197.154 159.782 173.422 158.218 165.902C158.706 161.8 159.097 161.8 158.511 159.359C160.955 156.722 165.257 151.253 167.212 150.862C173.665 149.495 177.575 158.284 178.651 169.613C178.944 172.836 179.922 195.493 179.824 198.912C179.726 203.795 176.5 207.31 173.567 208.971Z",
    fill: "url(#paint69_linear)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M171.808 151.839C170.048 150.569 170.243 149.69 170.537 147.932C170.928 147.054 171.123 145.979 171.123 144.905C171.123 140.999 168.581 137.58 165.55 137.776C159.391 138.166 160.467 141.487 160.467 145.393C160.467 149.007 162.129 151.546 164.866 151.937C164.866 152.522 163.4 153.792 162.813 154.671C165.844 157.015 168.972 154.28 170.146 153.792C171.319 153.206 172.687 152.718 171.808 151.839Z",
    fill: "#F6D3AF"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M168.19 138.068C167.408 137.678 166.626 137.873 166.235 137.58C165.159 136.897 164.182 136.506 163.595 136.799C163.302 136.994 162.813 137.385 162.813 137.385C162.226 137.971 161.151 136.799 160.858 138.166C160.76 138.557 160.76 138.947 160.76 139.24C158.12 139.533 159.391 141.975 161.542 146.663C161.542 145.881 163.106 144.123 163.106 147.542C163.106 147.932 162.813 147.932 163.106 148.421C163.302 148.909 164.866 150.081 165.844 151.057C167.212 152.425 168.581 150.667 170.928 150.96C170.634 150.471 170.634 149.983 171.025 149.397C171.221 149.007 172.492 147.737 172.492 145.588C170.732 145.881 173.958 140.998 168.19 138.068Z",
    fill: "#AF7120"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M139.447 171.176C141.011 169.906 143.749 169.515 145.606 170.199C147.366 170.785 147.561 171.469 148.246 172.25C147.757 172.738 148.148 173.422 146.29 173.813C145.411 173.52 144.531 174.301 143.162 172.934C141.793 171.566 141.891 171.176 141.891 171.176C139.056 171.957 139.056 171.566 139.447 171.176Z",
    fill: "#F4D1AD"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M160.564 157.894C157.338 157.308 156.654 167.66 156.654 174.398C155.089 173.715 150.005 172.25 147.659 171.469C145.704 171.469 144.922 172.738 146.29 174.594C149.223 176.547 156.947 181.918 160.369 180.746C163.791 179.574 163.791 171.078 164.084 166.879C164.475 162.777 164.475 158.577 160.564 157.894Z",
    fill: "url(#paint70_linear)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M465.536 126.741L453.532 133.643C452.895 134.034 452.258 134.034 451.866 133.79C451.425 133.545 451.18 133.006 451.18 132.223V118.421C451.18 117.638 451.425 116.806 451.866 116.071C452.307 115.337 452.895 114.652 453.532 114.309L465.536 107.408C466.173 107.017 466.81 107.017 467.202 107.261C467.643 107.506 467.888 108.045 467.888 108.828V122.63C467.888 123.413 467.643 124.245 467.202 124.979C466.81 125.665 466.222 126.35 465.536 126.741Z",
    fill: "#313131"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M451.179 132.272V118.47C451.179 117.687 451.424 116.855 451.865 116.12C452.306 115.386 452.894 114.701 453.531 114.358L465.536 107.457C466.173 107.066 466.81 107.066 467.202 107.31L451.522 98.2556C451.081 98.0109 450.493 98.0598 449.856 98.4025L437.852 105.304C437.215 105.695 436.578 106.332 436.186 107.066C435.745 107.8 435.5 108.632 435.5 109.415V123.266C435.5 124.05 435.745 124.539 436.186 124.833L451.865 133.887C451.473 133.545 451.179 133.006 451.179 132.272Z",
    fill: "#292929"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M449.416 114.652C449.857 113.918 450.445 113.233 451.082 112.89L463.086 105.989C463.723 105.598 464.36 105.597 464.752 105.842L465.487 106.283C465.046 106.038 464.458 106.087 463.821 106.43L451.817 113.331C451.18 113.722 450.543 114.359 450.151 115.093C449.71 115.827 449.465 116.659 449.465 117.442V131.245C449.465 132.028 449.71 132.517 450.151 132.811L449.416 132.37C448.975 132.126 448.73 131.587 448.73 130.804V117.002C448.681 116.219 448.975 115.386 449.416 114.652Z",
    fill: "url(#paint71_linear)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M447.406 113.478C447.847 112.744 448.435 112.058 449.072 111.716L461.077 104.814C461.713 104.423 462.35 104.423 462.742 104.668L463.477 105.108C463.036 104.863 462.448 104.912 461.811 105.255L449.807 112.156C449.17 112.548 448.533 113.184 448.141 113.918C447.7 114.652 447.455 115.484 447.455 116.268V130.07C447.455 130.853 447.7 131.343 448.141 131.636L447.406 131.196C446.965 130.951 446.72 130.413 446.72 129.63V115.778C446.671 115.093 446.965 114.212 447.406 113.478Z",
    fill: "url(#paint72_linear)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M445.348 112.303C445.789 111.569 446.377 110.884 447.014 110.541L459.018 103.64C459.655 103.248 460.292 103.248 460.684 103.493L461.419 103.933C460.978 103.689 460.39 103.738 459.753 104.08L447.749 110.981C447.112 111.373 446.475 112.009 446.083 112.743C445.642 113.478 445.397 114.31 445.397 115.093V128.944C445.397 129.727 445.642 130.217 446.083 130.51L445.348 130.07C444.907 129.825 444.662 129.287 444.662 128.504V114.652C444.662 113.918 444.956 113.086 445.348 112.303Z",
    fill: "url(#paint73_linear)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M443.34 111.177C443.781 110.443 444.369 109.758 445.006 109.415L457.01 102.514C457.647 102.122 458.284 102.073 458.676 102.367L459.411 102.808C458.97 102.563 458.382 102.612 457.745 102.954L445.789 109.807C445.153 110.198 444.516 110.835 444.124 111.569C443.683 112.303 443.438 113.135 443.438 113.918V127.77C443.438 128.553 443.683 129.042 444.124 129.336L443.389 128.895C442.948 128.651 442.703 128.112 442.703 127.329V113.478C442.654 112.743 442.948 111.911 443.34 111.177Z",
    fill: "url(#paint74_linear)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M441.33 110.003C441.771 109.268 442.359 108.583 442.996 108.241L455.001 101.339C455.638 100.948 456.275 100.948 456.667 101.193L457.402 101.633C456.961 101.388 456.373 101.437 455.736 101.78L443.731 108.681C443.094 109.073 442.457 109.709 442.065 110.443C441.624 111.177 441.38 112.009 441.38 112.792V126.644C441.38 127.427 441.624 127.916 442.065 128.21L441.33 127.77C440.89 127.525 440.645 126.987 440.645 126.203V112.352C440.645 111.569 440.89 110.737 441.33 110.003Z",
    fill: "url(#paint75_linear)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M439.323 108.828C439.764 108.094 440.352 107.408 440.989 107.066L452.993 100.165C453.63 99.773 454.267 99.773 454.659 100.018L455.394 100.458C454.953 100.214 454.365 100.262 453.728 100.605L441.724 107.506C441.087 107.898 440.45 108.534 440.058 109.268C439.617 110.003 439.372 110.835 439.372 111.618V125.469C439.372 126.252 439.617 126.742 440.058 127.035L439.323 126.595C438.882 126.35 438.637 125.812 438.637 125.029V111.226C438.637 110.443 438.882 109.562 439.323 108.828Z",
    fill: "url(#paint76_linear)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M437.313 107.653C437.754 106.919 438.342 106.234 438.979 105.891L450.983 98.9899C451.62 98.5983 452.257 98.5984 452.649 98.8431L453.384 99.2836C452.943 99.0389 452.355 99.0878 451.718 99.4304L439.714 106.332C439.077 106.723 438.44 107.359 438.048 108.094C437.607 108.828 437.362 109.66 437.362 110.443V124.294C437.362 125.078 437.607 125.567 438.048 125.861L437.313 125.42C436.872 125.175 436.627 124.637 436.627 123.854V110.051C436.627 109.268 436.872 108.436 437.313 107.653Z",
    fill: "url(#paint77_linear)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M437.189 114.828C437.43 115.069 438.477 117.964 436.303 118.849C435.177 118.206 434.854 115.311 437.189 114.828Z",
    fill: "#292929"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M435.822 114.828L437.19 115.311C437.995 115.552 439.927 115.15 441.054 114.024C442.181 112.898 442.423 115.07 441.135 115.713C439.847 116.356 439.847 116.839 441.94 117.241C442.906 117.402 443.952 117.964 444.274 118.286C444.999 119.01 445.884 120.698 444.677 121.503C443.711 122.146 440.893 120.859 440.008 120.538C437.593 119.573 438.076 119.09 436.788 118.447C435.419 117.804 435.178 117.804 435.178 117.804L435.822 114.828Z",
    fill: "#F6D3AF"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M424.792 91.2676C423.263 90.9459 421.331 91.1872 420.043 95.6902C418.916 99.4696 419.801 107.189 420.526 109.28C422.216 114.748 428.978 116.678 436.384 118.768C435.418 117.723 436.062 115.311 437.27 114.748C432.279 112.577 427.61 109.441 426 107.752C426 105.903 426.885 98.7459 427.046 96.3335C427.127 93.3583 426.241 91.5892 424.792 91.2676Z",
    fill: "#59595B"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M419.078 45.8348H404.91L413.765 51.0616L404.91 56.208H419.078L428.094 50.9812L419.078 45.8348Z",
    fill: "url(#paint78_linear)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M402.848 58.3482L413.765 52.0034V39.2146L402.848 45.5594V58.3482Z",
    fill: "#292929"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M402.847 58.3482L392.029 52.0034V39.2146L402.847 45.5594V58.3482Z",
    fill: "#313131"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M402.847 45.5594L392.029 39.2146L402.847 32.9689L413.764 39.2146L402.847 45.5594Z",
    fill: "#C0162E"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M371.297 124.038H359.025L366.683 128.557L359.025 132.883H371.297L379.15 128.461L371.297 124.038Z",
    fill: "url(#paint79_linear)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M358.812 133.124L366.551 128.665V119.449L358.812 124.007V133.124Z",
    fill: "#292929"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M358.812 133.124L350.975 128.665V119.449L358.812 124.007V133.124Z",
    fill: "#CACACB"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M358.812 124.007L350.975 119.449L358.812 114.989L366.55 119.449L358.812 124.007Z",
    fill: "#F1ECEC"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M107.788 299.937H101.67L104.971 301.867L87.8242 311.757H93.8616L111.088 301.867L107.788 299.937Z",
    fill: "url(#paint80_linear)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8239 308.219L84.5234 306.37L98.4497 298.329L96.1153 296.962L99.3352 295.112L104.97 298.329L87.8239 308.219Z",
    fill: "url(#paint81_linear)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8239 311.757L84.5234 309.908V306.37L87.8239 308.219V311.757Z",
    fill: "#F1ECEC"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1152 299.696V296.962L98.4497 298.329L96.1152 299.696Z",
    fill: "#F1ECEC"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M105.131 301.786L87.9844 311.677V308.139L105.131 298.248V301.786Z",
    fill: "#59595B"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M493.54 427.712C490.239 425.782 490.239 422.646 493.54 420.716L499.255 417.419C502.556 415.489 508.03 415.489 511.33 417.419C514.631 419.349 514.631 422.485 511.33 424.415L505.615 427.712C502.314 429.642 496.921 429.642 493.54 427.712ZM508.11 419.349C506.581 418.464 504.085 418.464 502.475 419.349L496.76 422.646C495.23 423.53 495.23 424.978 496.76 425.862C498.289 426.747 500.785 426.747 502.395 425.862L508.11 422.565C509.72 421.681 509.72 420.233 508.11 419.349Z",
    fill: "url(#paint82_linear)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M490.319 424.254C487.019 422.324 487.019 419.188 490.319 417.258L496.035 413.961C499.335 412.031 504.809 412.031 508.109 413.961C511.41 415.891 511.41 419.027 508.109 420.957L502.394 424.254C499.093 426.184 493.62 426.184 490.319 424.254ZM504.889 415.811C503.36 414.926 500.864 414.926 499.255 415.811L493.539 419.107C492.01 419.992 492.01 421.439 493.539 422.324C495.069 423.208 497.564 423.208 499.174 422.324L504.889 419.027C506.419 418.143 506.419 416.695 504.889 415.811Z",
    fill: "white"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M504.89 415.811C503.361 414.926 500.865 414.926 499.255 415.811L493.54 419.108C492.01 419.992 492.01 421.44 493.54 422.324C493.62 422.404 493.701 422.404 493.781 422.485L499.255 419.349C500.704 418.545 503.039 418.464 504.568 419.188L504.81 419.027C506.42 418.143 506.42 416.695 504.89 415.811Z",
    fill: "#59595B"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M508.11 420.957L502.395 424.254C499.094 426.184 493.62 426.184 490.32 424.254C488.629 423.289 487.824 422.083 487.824 420.796V424.254C487.824 425.541 488.629 426.827 490.32 427.792C493.62 429.722 499.094 429.722 502.395 427.792L508.11 424.495C509.8 423.53 510.605 422.244 510.605 421.037V417.499C510.605 418.705 509.8 419.992 508.11 420.957Z",
    fill: "#59595B"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3543 317.547C41.0538 315.617 41.0538 312.481 44.3543 310.551L50.0697 307.254C53.3702 305.325 58.8441 305.325 62.1446 307.254C65.445 309.184 65.445 312.32 62.1446 314.25L56.4291 317.547C53.1287 319.477 47.7352 319.477 44.3543 317.547ZM58.9246 309.184C57.3951 308.3 54.8997 308.3 53.2897 309.184L47.5742 312.481C46.0447 313.366 46.0447 314.813 47.5742 315.698C49.1037 316.582 51.5992 316.582 53.2091 315.698L58.9246 312.401C60.5346 311.516 60.5346 310.069 58.9246 309.184Z",
    fill: "url(#paint83_linear)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1335 314.089C37.8331 312.16 37.8331 309.023 41.1335 307.094L46.849 303.797C50.1495 301.867 55.6234 301.867 58.9239 303.797C62.2243 305.727 62.2243 308.863 58.9239 310.792L53.2084 314.089C49.9079 316.019 44.434 316.019 41.1335 314.089ZM55.7039 305.646C54.1744 304.762 51.679 304.762 50.069 305.646L44.3535 308.943C42.824 309.828 42.824 311.275 44.3535 312.16C45.883 313.044 48.3785 313.044 49.9884 312.16L55.7039 308.863C57.2334 307.978 57.2334 306.531 55.7039 305.646Z",
    fill: "white"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7045 305.646C54.175 304.762 51.6796 304.762 50.0696 305.646L44.3541 308.943C42.8247 309.828 42.8247 311.275 44.3541 312.159C44.4346 312.24 44.5152 312.24 44.5957 312.32L50.0696 309.184C51.5186 308.38 53.853 308.3 55.3825 309.023L55.624 308.863C57.234 307.978 57.234 306.531 55.7045 305.646Z",
    fill: "#59595B"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9244 310.793L53.209 314.089C49.9085 316.019 44.4346 316.019 41.1341 314.089C39.4436 313.124 38.6387 311.918 38.6387 310.632V314.089C38.6387 315.376 39.4436 316.663 41.1341 317.628C44.4346 319.557 49.9085 319.557 53.209 317.628L58.9244 314.331C60.6149 313.366 61.4199 312.079 61.4199 310.873V307.335C61.4199 308.541 60.6149 309.828 58.9244 310.793Z",
    fill: "#59595B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 517.179,
    y1: 314.557,
    x2: 554.106,
    y2: 314.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3028,
    stopColor: "#D3D7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8627,
    stopColor: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 590.533,
    y1: 294.389,
    x2: 612.981,
    y2: 294.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#D7D9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    stopColor: "#EDEEF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7487,
    stopColor: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 540.168,
    y1: 80.3315,
    x2: 540.168,
    y2: 101.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 515.424,
    y1: 93.5705,
    x2: 506.433,
    y2: 80.8136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232639,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539931,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 517.84,
    y1: 92.1231,
    x2: 508.849,
    y2: 79.3662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232639,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539931,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 520.254,
    y1: 90.7561,
    x2: 511.264,
    y2: 77.9992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232639,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539931,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 522.668,
    y1: 89.3891,
    x2: 513.678,
    y2: 76.6321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232639,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539931,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 525.091,
    y1: 87.9417,
    x2: 516.102,
    y2: 75.1796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232639,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539931,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 527.505,
    y1: 86.5747,
    x2: 518.516,
    y2: 73.8127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232639,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539931,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 529.921,
    y1: 85.2077,
    x2: 520.932,
    y2: 72.4456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232639,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539931,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 451.278,
    y1: 170.554,
    x2: 451.278,
    y2: 177.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 443.468,
    y1: 161.467,
    x2: 443.468,
    y2: 165.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 441.457,
    y1: 104.358,
    x2: 401.281,
    y2: 123.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 155.246,
    y1: 192.892,
    x2: 109.265,
    y2: 112.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 181.302,
    y1: 152.622,
    x2: 181.302,
    y2: 232.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 441.407,
    y1: 198.618,
    x2: 441.407,
    y2: 381.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 160.813,
    y1: 450.315,
    x2: 282.569,
    y2: 380.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2429,
    stopColor: "#EDEFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6427,
    stopColor: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 236.529,
    y1: 452.657,
    x2: 236.529,
    y2: 364.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1461,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 452.435,
    y1: 283.462,
    x2: 452.435,
    y2: 234.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1461,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 471.321,
    y1: 160.663,
    x2: 471.321,
    y2: 278.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 321.391,
    y1: 158.753,
    x2: 321.391,
    y2: 310.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 189.959,
    y1: 312.211,
    x2: 452.802,
    y2: 312.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5787,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 174.233,
    y1: 458.943,
    x2: 174.233,
    y2: 303.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1461,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 108.754,
    y1: 363.985,
    x2: 288.508,
    y2: 363.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 136.461,
    y1: 400.917,
    x2: 288.521,
    y2: 400.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.571181,
    stopColor: "#F1ECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6429,
    stopColor: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 108.834,
    y1: 366.679,
    x2: 248.58,
    y2: 366.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 449.804,
    y1: 203.075,
    x2: 482.553,
    y2: 203.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#D7D9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    stopColor: "#EDEEF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7487,
    stopColor: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 467.634,
    y1: 242.537,
    x2: 486.734,
    y2: 242.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#D7D9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    stopColor: "#EDEEF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7487,
    stopColor: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 565.505,
    y1: 188.968,
    x2: 565.505,
    y2: 208.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 553.391,
    y1: 205.614,
    x2: 553.391,
    y2: 214.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 500.726,
    y1: 193.738,
    x2: 523.565,
    y2: 193.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8095,
    stopColor: "#F4F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 404.527,
    y1: 333.157,
    x2: 404.527,
    y2: 284.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1461,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 394.685,
    y1: 325.588,
    x2: 394.685,
    y2: 303.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 391.189,
    y1: 314.336,
    x2: 400.528,
    y2: 301.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0250151,
    stopColor: "#2F2E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0873867,
    stopColor: "#555596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1563,
    stopColor: "#7677B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2313,
    stopColor: "#9294C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3143,
    stopColor: "#A9ACD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4088,
    stopColor: "#BBBEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#C7CBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6705,
    stopColor: "#CED2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D4F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 392.342,
    y1: 314.738,
    x2: 401.446,
    y2: 302.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1327,
    stopColor: "#3F3E84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3363,
    stopColor: "#6C6DA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#8F91C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7118,
    stopColor: "#A8ACD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8735,
    stopColor: "#B8BBE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC1E4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(400.302 299.78) scale(4.35904 4.35433)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0162E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 256.59,
    y1: 225.66,
    x2: 429.908,
    y2: 225.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5628,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 343.348,
    y1: 240.454,
    x2: 343.348,
    y2: 131.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1461,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 248.542,
    y1: 209.881,
    x2: 437.957,
    y2: 209.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5628,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 339.424,
    y1: 266.797,
    x2: 339.424,
    y2: 273.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 338.498,
    y1: 266.566,
    x2: 338.498,
    y2: 269.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 272.062,
    y1: 172.669,
    x2: 414.395,
    y2: 172.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5787,
    stopColor: "#F7F7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 272.058,
    y1: 187.599,
    x2: 414.4,
    y2: 187.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2632,
    stopColor: "#CACFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D6DAEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7975,
    stopColor: "#EAECF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 342.953,
    y1: 226.883,
    x2: 342.953,
    y2: 148.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 380.92,
    y1: 117.241,
    x2: 388.326,
    y2: 117.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 322.721,
    y1: 121.101,
    x2: 330.127,
    y2: 121.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 335.279,
    y1: 99.3089,
    x2: 347.354,
    y2: 99.3089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 375.77,
    y1: 82.1811,
    x2: 380.76,
    y2: 82.1811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 403.461,
    y1: 127.775,
    x2: 407.164,
    y2: 127.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 397.021,
    y1: 92.0718,
    x2: 400.724,
    y2: 92.0718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 277.238,
    y1: 118.929,
    x2: 283.517,
    y2: 118.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 296.559,
    y1: 67.8678,
    x2: 300.262,
    y2: 67.8678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 367.799,
    y1: 20.7463,
    x2: 371.502,
    y2: 20.7463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 352.021,
    y1: 61.0328,
    x2: 357.817,
    y2: 61.0328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: 378.908,
    y1: 48.006,
    x2: 382.611,
    y2: 48.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: 333.426,
    y1: 46.1565,
    x2: 337.129,
    y2: 46.1565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: 557.255,
    y1: 350.677,
    x2: 557.255,
    y2: 362.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: 552.552,
    y1: 358.962,
    x2: 552.552,
    y2: 345.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1461,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: 25.2376,
    y1: 393.215,
    x2: 25.2376,
    y2: 404.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 498.652,
    y1: 138.952,
    x2: 498.652,
    y2: 150.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: 438.92,
    y1: 380.268,
    x2: 438.92,
    y2: 386.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x1: 453.975,
    y1: 371.423,
    x2: 453.975,
    y2: 377.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear",
    x1: 529.119,
    y1: 263.751,
    x2: 529.119,
    y2: 269.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear",
    x1: 515.355,
    y1: 272.356,
    x2: 515.355,
    y2: 278.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear",
    x1: 177.82,
    y1: 232.214,
    x2: 177.82,
    y2: 237.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear",
    x1: 191.996,
    y1: 223.912,
    x2: 174.839,
    y2: 221.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear",
    x1: 168.613,
    y1: 227.214,
    x2: 179.774,
    y2: 227.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353434",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear",
    x1: 154.32,
    y1: 235.525,
    x2: 165.48,
    y2: 235.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353434",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear",
    x1: 172.476,
    y1: 168.135,
    x2: 181.702,
    y2: 168.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#8F8FA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear",
    x1: 155.783,
    y1: 180.658,
    x2: 179.795,
    y2: 180.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#8F8FA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear",
    x1: 146.036,
    y1: 169.365,
    x2: 165.898,
    y2: 169.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#8F8FA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear",
    x1: 457.097,
    y1: 127.437,
    x2: 449.623,
    y2: 116.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear",
    x1: 455.087,
    y1: 126.262,
    x2: 447.613,
    y2: 115.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear",
    x1: 453.031,
    y1: 125.126,
    x2: 445.539,
    y2: 114.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear",
    x1: 451.045,
    y1: 123.957,
    x2: 443.557,
    y2: 113.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear",
    x1: 449.014,
    y1: 122.826,
    x2: 441.522,
    y2: 112.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear",
    x1: 447.006,
    y1: 121.651,
    x2: 439.514,
    y2: 111.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear",
    x1: 444.996,
    y1: 120.477,
    x2: 437.504,
    y2: 109.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear",
    x1: 416.502,
    y1: 45.8348,
    x2: 416.502,
    y2: 56.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear",
    x1: 369.088,
    y1: 124.038,
    x2: 369.088,
    y2: 132.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear",
    x1: 99.4563,
    y1: 299.937,
    x2: 99.4563,
    y2: 311.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear",
    x1: 94.7533,
    y1: 308.222,
    x2: 94.7533,
    y2: 295.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1461,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6135,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear",
    x1: 491.066,
    y1: 422.59,
    x2: 513.905,
    y2: 422.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8095,
    stopColor: "#F4F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear",
    x1: 41.8801,
    y1: 312.426,
    x2: 64.7194,
    y2: 312.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8095,
    stopColor: "#F4F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCollectionHero);
export default __webpack_public_path__ + "static/media/data_collection_hero.732cd79643a4a25660ad585de19c3afd.svg";
export { ForwardRef as ReactComponent };